"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[733],{

/***/ 84691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ SBlockContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(29725);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/CodeBlock/styles.ts
var styles = __webpack_require__(8643);
// EXTERNAL MODULE: ./src/components/UI/NoSSR/NoSSR.tsx
var NoSSR = __webpack_require__(7615);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/CodeBlock/SCodeBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  color: #aeaeae;\n  font-family: "IBM Plex Mono";\n  font-size: 12px;\n  padding: 5px;\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// TODO: replace with a high quality package
var CodeEditor = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3724), __webpack_require__.e(2954)]).then(__webpack_require__.bind(__webpack_require__, 23724)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23724)
            ];
        }
    },
    ssr: false
});
var SCodeBlock = function(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* NoSSR */.r, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledCodeBlockContent */.ur, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeEditor, {
                    className: "CodeEditor",
                    id: block.codeEitorId,
                    value: block.snapshot.plainText,
                    placeholder: "Enter some code",
                    language: block.snapshot.language,
                    padding: 25,
                    readOnly: true,
                    style: styles/* codeEditorStyles */.Pe
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguage, {
                    children: block.snapshot.language
                })
            ]
        })
    });
};
var StyledLanguage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f413b552-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/ColorBlock/styles.ts
var ColorBlock_styles = __webpack_require__(89140);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ColorBlock/SColorBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function SColorBlock(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorBlock_styles/* StyledColorBlockContent */.m, {
        color: block.snapshot.hex
    });
}

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/EmbeddedPlate/SEmbeddedPlate.tsx
var SEmbeddedPlate = __webpack_require__(35182);
// EXTERNAL MODULE: ./src/classes/block/block-types/index.ts + 10 modules
var block_types = __webpack_require__(20265);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/StandardFilePreview.tsx
var StandardFilePreview = __webpack_require__(16769);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/styles.ts
var FileBlock_styles = __webpack_require__(51993);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/Widgets/AudioWidget.tsx
var AudioWidget = __webpack_require__(48826);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/Widgets/VideoWidget.tsx
var VideoWidget = __webpack_require__(80342);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/PDFBlock/index.ts + 1 modules
var PDFBlock = __webpack_require__(63660);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/utility/FileStatusWrapper.tsx + 1 modules
var FileStatusWrapper = __webpack_require__(70967);
// EXTERNAL MODULE: ./src/components/Signup/SignupMethodButton.tsx
var SignupMethodButton = __webpack_require__(72423);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/FileBlock/SFileBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 









function SFileBlockContent(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FileBlock_styles/* StyledFileBlockContent */.Hr, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileStatusWrapper/* FileStatusWrapper */.k, {
            block: block,
            children: function() {
                switch(block.fileType){
                    case block_types/* FileType.Audio */.Tv.Audio:
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileBlock_styles/* FileBlockWrapper */.e5, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupMethodButton/* IconWrapper */.a1, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* AudioIcon */.f4, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileBlock_styles/* FileName */.dJ, {
                                    children: [
                                        block.fileDisplayName,
                                        " ",
                                        "(".concat(block.readableFileSize, ")")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioWidget/* AudioWidget */.I, {
                                    block: block,
                                    disableMouse: false
                                })
                            ]
                        });
                    case block_types/* FileType.Video */.Tv.Video:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWidget/* VideoWidget */.a, {
                            block: block,
                            disableMouse: false
                        });
                    case block_types/* FileType.PDF */.Tv.PDF:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFBlock/* PDFBlock */.F, {
                            block: block,
                            disableMouse: false
                        });
                    case block_types/* FileType.Other */.Tv.Other:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardFilePreview/* StandardFilePreview */.C, {
                            block: block
                        });
                }
            }()
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/ImageBlock/lib/Caption.tsx + 1 modules
var Caption = __webpack_require__(77545);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/ImageBlock/styles.ts
var ImageBlock_styles = __webpack_require__(40026);
// EXTERNAL MODULE: ./src/components/Block/styles.ts
var Block_styles = __webpack_require__(49516);
// EXTERNAL MODULE: ./src/components/UI/Loading/Spinners/ScribeSpinner/ScribeSpinner.tsx
var ScribeSpinner = __webpack_require__(68922);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ImageBlock/SImageBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 






function SImageBlock(param) {
    var block = param.block;
    var parentRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), imgLoading = ref[0], setImgLoading = ref[1];
    var ref1 = (0,react.useState)(0), parentWidth = ref1[0], setParentWidth = ref1[1];
    (0,react.useEffect)(function() {
        if (parentRef.current) {
            setParentWidth(parentRef.current.getBoundingClientRect().width);
        }
    }, [
        parentRef.current
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageBlock_styles/* StyledImageBlockContent */.sR, {
        ref: parentRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FileStatusWrapper/* FileStatusWrapper */.k, {
                block: block,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock_styles/* StyledImage */.Yo, {
                    style: {
                        objectFit: "cover",
                        display: imgLoading ? "none" : "block"
                    },
                    alt: "block",
                    src: block.getImageLinkForSize(parentWidth > 400 ? "biggest" : "standard"),
                    onLoad: function() {
                        return setImgLoading(false);
                    }
                })
            }),
            !!block.snapshot.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption/* Caption */.Y, {
                block: block,
                editable: false
            }),
            imgLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block_styles/* StyledLoadingMessage */.VX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScribeSpinner/* ScribeSpinner */.k, {})
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/LinkBlock/index.ts + 8 modules
var LinkBlock = __webpack_require__(28798);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/TextBlock/styles.ts
var TextBlock_styles = __webpack_require__(33237);
// EXTERNAL MODULE: ./src/components/ViennaEditor/index.ts + 8 modules
var ViennaEditor = __webpack_require__(59422);
// EXTERNAL MODULE: ./src/components/ViennaEditor/lib/helpers.ts + 1 modules
var helpers = __webpack_require__(47306);
// EXTERNAL MODULE: ./src/components/ViennaEditor/lib/initialize.ts + 1 modules
var initialize = __webpack_require__(64304);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/TextBlock/STextBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 






function STextBlock(param) {
    var block = param.block;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var initialValue = (0,helpers/* getTextContent */.FB)(block.snapshot);
    var ref = (0,react.useState)((0,initialize/* initializeViennaEditor */.y)()), editor = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlock_styles/* StyledTextBlockContent */.c, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViennaEditor/* ViennaEditor */.z, {
            editor: editor,
            initialValue: initialValue,
            readOnly: true,
            textSubtype: block.snapshot.textType,
            wrapperStyles: block.getEditorStyles(theme),
            editorId: block.textEditorId
        })
    });
}

// EXTERNAL MODULE: ./src/components/Block/Placeholders/ErrorBlock.tsx
var ErrorBlock = __webpack_require__(58369);
;// CONCATENATED MODULE: ./src/components/Block/BlockContent/SBlockContent.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 









function SBlockContent(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: function() {
            switch(block.snapshot.type){
                case dist.BlockType.Text:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(STextBlock, {
                        block: block
                    });
                case dist.BlockType.Image:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SImageBlock, {
                        block: block
                    });
                case dist.BlockType.Link:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkBlock/* SLinkBlockContent */.D, {
                        block: block
                    });
                case dist.BlockType.Color:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SColorBlock, {
                        block: block
                    });
                case dist.BlockType.Code:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SCodeBlock, {
                        block: block
                    });
                case dist.BlockType.File:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SFileBlockContent, {
                        block: block
                    });
                case dist.BlockType.PlateWindow:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SEmbeddedPlate/* SEmbeddedPlate */.o, {
                        plate: block.embeddedPlate
                    });
                case dist.BlockType.BlockWindow:
                    var blockWindow = block;
                    return blockWindow.embeddedBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SBlockContent, {
                        block: blockWindow.embeddedBlock
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        children: "Connected block not found."
                    });
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        children: "Block type not found."
                    });
            }
        }()
    });
}


/***/ }),

/***/ 38500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ BlockTopbarButtons; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/Connect/index.ts + 1 modules
var Connect = __webpack_require__(57459);
// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/IconButton.tsx
var IconButton = __webpack_require__(20195);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
;// CONCATENATED MODULE: ./src/components/UI/Buttons/IconButtons/Expand/Expand.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function Expand(param) {
    var expand = param.expand, numConnects = param.numConnects, id = param.id, styles = param.styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
        isSelected: false,
        handleClick: expand,
        tooltipText: "Expand block",
        id: id,
        styles: styles,
        children: numConnects ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: numConnects
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Expand */.M0, {})
    });
}

;// CONCATENATED MODULE: ./src/components/UI/Buttons/IconButtons/Expand/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/Like/index.ts + 1 modules
var Like = __webpack_require__(69397);
// EXTERNAL MODULE: ./src/lib/utils/device.ts
var device = __webpack_require__(30491);
;// CONCATENATED MODULE: ./src/components/Block/BlockTopbar/BlockTopbarButtons/BlockTopbarButtons.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 







/**
 * The buttons on the top right of a block
 */ function BlockTopbarButtons(param) {
    var block = param.block, hovering = param.hovering, isCurrentSession = param.isCurrentSession;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var loggedIn = !!(0,useCurrentUser/* useCurrentUser */.x)();
    var ref = (0,react.useState)(false), connectMenuOpen = ref[0], setConnectMenuOpen = ref[1];
    var isLiked = block.observe(function(state) {
        return state.isLiked;
    });
    var connectionCount = block.observe(function(state) {
        return state.connectionCount;
    });
    var hasConnections = connectionCount > 0;
    // button state logic is a little complicated...
    var showAllButtons = (isLiked || (0,device/* isTouchDevice */.b)() || hovering && !isCurrentSession) && loggedIn;
    var showLike = (showAllButtons || isLiked) && loggedIn; // isLiked is duplicated but makes it more readable
    var showExpand = (showAllButtons || hasConnections) && loggedIn;
    var showConnect = (showAllButtons || connectMenuOpen) && loggedIn;
    var styles = {
        borderLeft: "1px solid ".concat(theme.block.border)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: "flex"
        },
        className: "hide-on-print",
        children: [
            showLike && /*#__PURE__*/ (0,jsx_runtime.jsx)(Like/* Like */.m, {
                like: function() {
                    return block.like();
                },
                isLiked: isLiked,
                styles: styles
            }),
            showConnect && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Connect/* Connect */.l, {
                    block: block,
                    plate: null,
                    menuOpen: connectMenuOpen,
                    setMenuOpen: setConnectMenuOpen,
                    id: "cy-block-connect-button",
                    styles: styles
                })
            }),
            showExpand && /*#__PURE__*/ (0,jsx_runtime.jsx)(Expand, {
                expand: function() {
                    return block.open();
                },
                numConnects: connectionCount,
                id: "cy-block-drilled-button",
                styles: styles
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTopbar/BlockTopbarButtons/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 78650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ StyledBlockTopbar; },
/* harmony export */   "z": function() { return /* binding */ EmptySpace; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40974);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48876);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: ",
        "px;\n  border-bottom: ",
        ';\n  display: flex;\n  justify-content: flex-start;\n  overflow: hidden;\n  flex-shrink: 0;\n  font-family: "IBM Plex Mono";\n  font-size: 12px;\n  background-color: ',
        ";\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  /* grab cursor on windows platforms is ugly, blurry */\n  cursor: ",
        ";\n  &:active {\n    cursor: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledBlockTopbar = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-597f4f48-0"
})(_templateObject(), src_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .BLOCK_TOPBAR_HEIGHT */ .aU, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.block.border);
}, function(param) {
    var isSelected = param.isSelected, theme = param.theme, tintColor = param.tintColor;
    return tintColor ? tintColor : isSelected ? theme.button.hover : theme.background;
}, function(param) {
    var theme = param.theme, isSelectable = param.isSelectable;
    return isSelectable && theme.button.active;
});
var EmptySpace = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-597f4f48-1"
})(_templateObject1(), function(param) {
    var editable = param.editable;
    return editable && !react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isWindows */ .ED && "grab";
}, function(param) {
    var editable = param.editable;
    return editable && !react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isWindows */ .ED && "grabbing";
});


/***/ }),

/***/ 8643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pe": function() { return /* binding */ codeEditorStyles; },
/* harmony export */   "jr": function() { return /* binding */ StyledLanguage; },
/* harmony export */   "ur": function() { return /* binding */ StyledCodeBlockContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  color: #aeaeae;\n  font-family: "IBM Plex Mono";\n  font-size: 12px;\n  padding: 5px;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledCodeBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-879f5c22-0"
})(_templateObject());
var codeEditorStyles = {
    fontSize: 14,
    fontFamily: "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
    width: "100%",
    minHeight: "100%",
    backgroundColor: "#eeedea",
    lineHeight: "20px"
};
var StyledLanguage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-879f5c22-1"
})(_templateObject1());


/***/ }),

/***/ 89140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ StyledColorBlockContent; },
/* harmony export */   "z": function() { return /* binding */ ColorPicker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #000000;\n  background-color: transparent;\n  height: 30px;\n  width: 30px;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledColorBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-439612fa-0"
})(_templateObject(), function(param) {
    var color = param.color;
    return color;
});
var ColorPicker = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-439612fa-1"
})(_templateObject1());


/***/ }),

/***/ 35182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SEmbeddedPlate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var src_components_Block_BlockTypes_EmbeddedPlate_lib_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66772);
/* harmony import */ var src_components_Block_Placeholders_MessageBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67864);
/* harmony import */ var src_components_Shared_PageThumbnail__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12539);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function SEmbeddedPlate(param) {
    var plate = param.plate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Block_BlockTypes_EmbeddedPlate_lib_styles__WEBPACK_IMPORTED_MODULE_1__/* .EmbeddedPlateBlockContent */ ._7, {
        children: !plate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Block_Placeholders_MessageBlock__WEBPACK_IMPORTED_MODULE_2__/* .MessageBlock */ .t, {
            children: "Plate deleted"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Block_BlockTypes_EmbeddedPlate_lib_styles__WEBPACK_IMPORTED_MODULE_1__/* .PageBlockWrapper */ .OO, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Block_BlockTypes_EmbeddedPlate_lib_styles__WEBPACK_IMPORTED_MODULE_1__/* .PageBlockMaxWidth */ .gP, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Shared_PageThumbnail__WEBPACK_IMPORTED_MODULE_3__/* .PageThumbnail */ .G, {
                    plate: plate,
                    disableContextMenu: true
                })
            })
        })
    });
}


/***/ }),

/***/ 66772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OO": function() { return /* binding */ PageBlockWrapper; },
/* harmony export */   "_7": function() { return /* binding */ EmbeddedPlateBlockContent; },
/* harmony export */   "gP": function() { return /* binding */ PageBlockMaxWidth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 240px;\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var EmbeddedPlateBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-d8d899cc-0"
})(_templateObject());
var PageBlockMaxWidth = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d8d899cc-1"
})(_templateObject1());
var PageBlockWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d8d899cc-2"
})(_templateObject2());


/***/ }),

/***/ 16769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ StandardFilePreview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var src_components_Block_BlockTypes_FileBlock_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51993);
/* harmony import */ var src_components_UI_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51950);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


var StandardFilePreview = function(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Block_BlockTypes_FileBlock_styles__WEBPACK_IMPORTED_MODULE_1__/* .FileBlockWrapper */ .e5, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Block_BlockTypes_FileBlock_styles__WEBPACK_IMPORTED_MODULE_1__/* .IconWrapper */ .a1, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_UI_Icons__WEBPACK_IMPORTED_MODULE_2__/* .FileIcon */ .aA, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Block_BlockTypes_FileBlock_styles__WEBPACK_IMPORTED_MODULE_1__/* .FileName */ .dJ, {
                children: [
                    block.fileDisplayName,
                    " ",
                    block.readableFileSize
                ]
            })
        ]
    });
};


/***/ }),

/***/ 48826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ AudioWidget; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 35px;\n  height: 40px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  transform: scale(0.9);\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function AudioWidget(param) {
    var block = param.block, disableMouse = param.disableMouse;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AudioWidgetWrapper, {
        style: {
            pointerEvents: disableMouse ? "none" : "auto"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("audio", {
            controls: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                src: block.fileURL
            })
        })
    });
}
var AudioWidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-303acf9f-0"
})(_templateObject());


/***/ }),

/***/ 80342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ VideoWidget; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background-color: #f5f5f5;\n  height: 100%;\n  width: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  video {\n    max-height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  color: white;\n  font-size: 18px;\n  font-family: "IBM Plex Mono", sans-serif;\n  background-color: black;\n  padding-left: 5px;\n  padding-right: 5px;\n  user-select: text;\n  pointer-events: all;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function VideoWidget(param) {
    var block = param.block, disableMouse = param.disableMouse;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isHovering = ref[0], setIsHovering = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isPlaying = ref1[0], setIsPlaying = ref1[1];
    var showTitle = isHovering || !isPlaying;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(VideoWidgetWrapper, {
        style: {
            pointerEvents: disableMouse ? "none" : "auto"
        },
        children: [
            showTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    position: "absolute",
                    top: "5px",
                    left: "7px",
                    paddingRight: "7px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoTitle, {
                    children: block.fileDisplayName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                controls: isHovering,
                onMouseEnter: function() {
                    return setIsHovering(true);
                },
                onMouseLeave: function() {
                    return setIsHovering(false);
                },
                onPlay: function() {
                    return setIsPlaying(true);
                },
                onPause: function() {
                    return setIsPlaying(false);
                },
                title: block.snapshot.originalFilename,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                    src: block.fileURL
                })
            })
        ]
    });
}
var VideoWidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73d32735-0"
})(_templateObject());
var VideoTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73d32735-1"
})(_templateObject1());


/***/ }),

/***/ 51993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hr": function() { return /* binding */ StyledFileBlockContent; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "dJ": function() { return /* binding */ FileName; },
/* harmony export */   "e5": function() { return /* binding */ FileBlockWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  color: #aeaeae;\n  &:hover {\n    color: ",
        ';\n  }\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  font-family: "IBM Plex Mono";\n  word-break: break-all;\n  padding: 15px;\n  height: 100%;\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledFileBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-517d701b-0"
})(_templateObject());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-517d701b-1"
})(_templateObject1());
var FileBlockWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-517d701b-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var FileName = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-517d701b-3"
})(_templateObject3());


/***/ }),

/***/ 77545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ Caption; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ImageBlock/lib/EditableCaption.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  max-width: 80%;\n  left: 3px;\n  bottom: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: absolute;\n  background: rgba(225, 225, 225, 0.85);\n  border: 1px solid black;\n  font-size: 14px;\n  padding-left: 3px;\n  padding-right: 3px;\n  width: 100%;\n  font-family: "IBM Plex Sans", sans-serif;\n  white-space: nowrap;\n  overflow-x: ellipsis;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 14px;\n  padding-left: 3px;\n  padding-right: 3px;\n  width: 100%;\n  font-family: "IBM Plex Sans", sans-serif;\n  white-space: nowrap;\n  word-wrap: break-word;\n  visibility: hidden;\n  pointer-events: none;\n  user-select: none;\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



function EditableCaption(param) {
    var block = param.block;
    var captionRef = react.useRef(null);
    var ref = (0,react.useState)(block.snapshot.caption || ""), value = ref[0], setValue = ref[1];
    var save = function() {
        if (value.trim() === "") {
            block.removeCaption();
        } else {
            block.updateCaption(value);
        }
    };
    var handleKeyDown = function(e) {
        e.stopPropagation();
        switch(e.code){
            case "Enter":
            case "Escape":
                var ref;
                e.preventDefault();
                save();
                (ref = captionRef.current) === null || ref === void 0 ? void 0 : ref.blur();
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResizeableInput, {
                value: value,
                onChange: function(e) {
                    return setValue(e.target.value.slice(0, 50));
                },
                onKeyDown: handleKeyDown,
                onBlur: function() {
                    return save();
                },
                maxLength: 50,
                autoFocus: !value,
                ref: captionRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputClone, {
                children: [
                    value,
                    "\xa0"
                ]
            })
        ]
    });
}
var InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6a890b04-0"
})(_templateObject());
var ResizeableInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-6a890b04-1"
})(_templateObject1());
var InputClone = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-6a890b04-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/ImageBlock/lib/Caption.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Caption_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: absolute;\n  left: 3px;\n  bottom: 3px;\n  background: rgba(225, 225, 225, 0.85);\n  font-size: 14px;\n  font-family: Inter;\n  padding-left: 3px;\n  padding-right: 3px;\n  border: 1px solid black;\n  max-width: 80%;\n  font-family: "IBM Plex Sans", sans-serif;\n  white-space: nowrap;\n'
    ]);
    Caption_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Caption(param) {
    var editable = param.editable, block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: editable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditableCaption, {
            block: block
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadOnlyCaption, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    overflow: "hidden"
                },
                children: block.snapshot.caption
            })
        })
    });
}
var ReadOnlyCaption = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4e1feb15-0"
})(Caption_templateObject());


/***/ }),

/***/ 40026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yo": function() { return /* binding */ StyledImage; },
/* harmony export */   "mS": function() { return /* binding */ StyledImagePicker; },
/* harmony export */   "sR": function() { return /* binding */ StyledImageBlockContent; },
/* harmony export */   "x1": function() { return /* binding */ HiddenInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  .loading {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  font-family: "IBM Plex Mono";\n  color: ',
        ";\n  cursor: pointer;\n  text-decoration: underline;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledImageBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-1ef164f4-0"
})(_templateObject());
var StyledImage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-1ef164f4-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary;
});
var StyledImagePicker = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-1ef164f4-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});
var HiddenInput = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-1ef164f4-3"
})(_templateObject3());


/***/ }),

/***/ 28798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ LinkBlockContent; },
  "D": function() { return /* reexport */ SLinkBlockContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(86524);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/LinkBlock/styles.ts
var styles = __webpack_require__(247);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/Instagram/InstagramEmbed.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

var InstagramEmbed = function(param) {
    var embedId = param.embedId, disableMouse = param.disableMouse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledIframe */.y, {
        title: "instagram-".concat(embedId),
        src: "https://www.instagram.com/p/".concat(embedId, "embed"),
        width: "100%",
        height: "100%",
        frameBorder: "0",
        allowFullScreen: true,
        disableMouse: disableMouse,
        allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
    });
};

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/Spotify/SpotifyEmbed.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

var SpotifyEmbed = function(param) {
    var embedId = param.embedId, blockId = param.blockId, disableMouse = param.disableMouse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledIframe */.y, {
        title: "spotify-".concat(embedId),
        src: "https://open.spotify.com/embed/".concat(embedId),
        frameBorder: "0",
        allowFullScreen: true,
        allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
        style: {
            visibility: "visible",
            height: "100%",
            width: "100%"
        },
        disableMouse: disableMouse,
        id: "spotify-".concat(blockId)
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react-twitter-widgets/es/index.js + 1 modules
var react_twitter_widgets_es = __webpack_require__(21412);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/Twitter/TwitterEmbed.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -10px;\n  padding: 10px;\n  height: 100%;\n  width: 100%;\n  pointer-events: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TwitterEmbed = function(param) {
    var tweetId = param.tweetId, theme = param.theme, disableMouse = param.disableMouse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TweetWrapper, {
        disableMouse: disableMouse,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_twitter_widgets_es/* Tweet */.tP, {
            options: {
                align: "center",
                theme: theme
            },
            tweetId: tweetId
        })
    });
};
var TweetWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-36f3acdf-0"
})(_templateObject(), function(param) {
    var disableMouse = param.disableMouse;
    return disableMouse ? "none" : "auto";
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ./src/classes/block/block-types/index.ts + 10 modules
var block_types = __webpack_require__(20265);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14129);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(5170);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/Youtube/Icons.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
var YouTubePlayButton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: "69px",
        height: "69px",
        viewBox: "0 0 69 69",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                style: {
                    stroke: "none",
                    strokeWidth: "0",
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: "10",
                    fill: "none",
                    fillRule: "nonzero",
                    opacity: "1"
                },
                transform: "translate(1.4065934065934016 0) scale(0.75740 0.75740)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 88.119 23.338 c -1.035 -3.872 -4.085 -6.922 -7.957 -7.957 C 73.144 13.5 45 13.5 45 13.5 s -28.144 0 -35.162 1.881 c -3.872 1.035 -6.922 4.085 -7.957 7.957 C 0 30.356 0 45 0 45 s 0 14.644 1.881 21.662 c 1.035 3.872 4.085 6.922 7.957 7.957 C 16.856 76.5 45 76.5 45 76.5 s 28.144 0 35.162 -1.881 c 3.872 -1.035 6.922 -4.085 7.957 -7.957 C 90 59.644 90 45 90 45 S 90 30.356 88.119 23.338 z",
                        style: {
                            stroke: "none",
                            strokeWidth: "1",
                            strokeDasharray: "none",
                            strokeLinecap: "butt",
                            strokeLinejoin: "miter",
                            strokeMiterlimit: "10",
                            fill: "rgb(20,20,20)",
                            fillRule: "nonzero",
                            opacity: 0.7
                        },
                        transform: " matrix(1 0 0 1 0 0) ",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                        points: "36,58.5 59.38,45 36,31.5 ",
                        style: {
                            stroke: "none",
                            strokeWidth: "1",
                            strokeDasharray: "none",
                            strokeLinecap: "butt",
                            strokeLinejoin: "miter",
                            strokeMiterlimit: "10",
                            fill: "rgb(255,255,255)",
                            fillRule: "nonzero",
                            opacity: "1"
                        },
                        transform: " matrix(1 0 0 1 0 0) "
                    })
                ]
            })
        ]
    });
}; // export const ShareButton = () => (
 //   <svg height="100%" version="1.1" viewBox="0 0 36 36" width="100%">
 //     <use className="ytp-svg-shadow" xlinkHref="#ytp-id-56"></use>
 //     <path
 //       className="ytp-svg-fill"
 //       d="m 20.20,14.19 0,-4.45 7.79,7.79 -7.79,7.79 0,-4.56 C 16.27,20.69 12.10,21.81 9.34,24.76 8.80,25.13 7.60,27.29 8.12,25.65 9.08,21.32 11.80,17.18 15.98,15.38 c 1.33,-0.60 2.76,-0.98 4.21,-1.19 z"
 //       id="ytp-id-56"
 //       fill="#DDD"
 //     ></path>
 //   </svg>
 // );
 // export const VerticalDots = () => (
 //   <svg height="100%" viewBox="-5 -5 36 36" width="100%">
 //     <path
 //       d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
 //       fill="#DDD"
 //     ></path>
 //   </svg>
 // );

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/Youtube/YoutubeFacade.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function YoutubeFacade_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  min-height: 80px;\n  align-self: center;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  flex-direction: column;\n"
    ]);
    YoutubeFacade_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-top: 12px;\n  margin-left: 12px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: 100%;\n  height: 60px;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  position: relative;\n  flex-grow: 1;\n  font-size: 18px;\n  margin-top: 21px;\n  margin-left: 10px;\n  margin-right: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 200;\n  font-family: "RobotoLight", Arial, sans-serif;\n  letter-spacing: 0.12px;\n  color: white;\n  text-shadow: 0 0 2px rgb(0 0 0 / 50%);\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




/**
 * From https://github.com/ibrahimcesar/react-lite-youtube-embed
 */ function YoutubeFacade(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), preconnected = ref[0], setPreconnected = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), iframe = ref1[0], setIframe = ref1[1];
    var videoId = encodeURIComponent(props.id);
    var videoPlaylisCovertId = typeof props.playlistCoverId === "string" ? encodeURIComponent(props.playlistCoverId) : null;
    var videoTitle = props.title;
    var posterImp = props.poster || "hqdefault";
    var paramsImp = "&".concat(props.params) || 0;
    var mutedImp = props.muted ? "&mute=1" : "";
    var format = props.webp ? "webp" : "jpg";
    var vi = props.webp ? "vi_webp" : "vi";
    var posterUrl = props.thumbnail || (!props.playlist ? "https://i.ytimg.com/".concat(vi, "/").concat(videoId, "/").concat(posterImp, ".").concat(format) : "https://i.ytimg.com/".concat(vi, "/").concat(videoPlaylisCovertId, "/").concat(posterImp, ".").concat(format));
    var youtubeURL = props.noCookie ? "https://www.youtube-nocookie.com" : "https://www.youtube.com";
    youtubeURL = props.cookie ? "https://www.youtube.com" : "https://www.youtube-nocookie.com";
    var iframeSrc = !props.playlist ? "".concat(youtubeURL, "/embed/").concat(videoId, "?autoplay=1&state=1").concat(mutedImp).concat(paramsImp) : "".concat(youtubeURL, "/embed/videoseries?autoplay=1").concat(mutedImp, "&list=").concat(videoId).concat(paramsImp);
    var activatedClassImp = props.activatedClass || "lyt-activated";
    var adNetworkImp = props.adNetwork || false;
    var aspectHeight = props.aspectHeight || 9;
    var aspectWidth = props.aspectWidth || 16;
    var iframeClassImp = props.iframeClass || "";
    var wrapperClassImp = props.wrapperClass || "yt-lite";
    var onIframeAdded = props.onIframeAdded || function() {};
    var rel = props.rel ? "prefetch" : "preload";
    var warmConnections = function() {
        if (preconnected) return;
        setPreconnected(true);
    };
    var addIframe = function() {
        if (iframe) return;
        setIframe(true);
    };
    react.useEffect(function() {
        if (iframe) {
            onIframeAdded();
        }
    }, [
        iframe
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: rel,
                href: posterUrl,
                as: "image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: preconnected && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "preconnect",
                            href: youtubeURL
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "preconnect",
                            href: "https://www.google.com"
                        }),
                        adNetworkImp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "preconnect",
                                    href: "https://static.doubleclick.net"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "preconnect",
                                    href: "https://googleads.g.doubleclick.net"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                onPointerOver: warmConnections,
                onClick: addIframe,
                className: "".concat(wrapperClassImp, " ").concat(iframe ? activatedClassImp : ""),
                "data-title": videoTitle,
                style: (0,_object_spread/* default */.Z)({
                    backgroundImage: "url(".concat(posterUrl, ")")
                }, {
                    "--aspect-ratio": "".concat(aspectHeight / aspectWidth * 100, "%")
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(YoutubeTopbar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelIconWrapper, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeTitle, {
                                children: videoTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTubePlayButton, {})
                    }),
                    iframe && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        className: iframeClassImp,
                        title: videoTitle,
                        style: {
                            width: "100%",
                            height: "100%",
                            border: "none",
                            pointerEvents: props.disableMouse ? "none" : "auto"
                        },
                        frameBorder: "0",
                        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true,
                        src: iframeSrc
                    })
                ]
            })
        ]
    });
}
var YoutubePlayWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13bcf2b5-0"
})(YoutubeFacade_templateObject());
var ChannelIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13bcf2b5-1"
})(_templateObject1());
// const ButtonLabel = styled.div`
//   position: relative;
//   font-size: 14px;
//   font-family: RobotoLight, sans-serif;
//   color: #fff;
//   white-space: nowrap;
// `;
// const IconWrapper = styled.div`
//   position: relative;
//   height: 35px;
//   width: 35x;
// `;
// const ButtonWrapper = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   line-height: 20px;
//   padding-top: 6px;
//   margin-right: 10px;
//   width: 70px;
//   flex-shrink: 0;
// `;
var YoutubeTopbar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13bcf2b5-2"
})(_templateObject2());
var YoutubeTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13bcf2b5-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/Youtube/YouTubeEmbed.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



var YoutubeEmbed = function(param) {
    var youtubeId = param.youtubeId, disableMouse = param.disableMouse;
    var ref = (0,react.useState)(""), title = ref[0], setTitle = ref[1];
    (0,react.useEffect)(function() {
        block_types/* EmbedIdentifier.getYoutubeTitleFromId */.UV.getYoutubeTitleFromId(youtubeId).then(function(res) {
            setTitle(res);
        });
    }, [
        youtubeId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeFacade, {
        id: youtubeId,
        title: title,
        disableMouse: disableMouse
    });
};

// EXTERNAL MODULE: ./src/components/Block/Placeholders/ErrorBlock.tsx
var ErrorBlock = __webpack_require__(58369);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/LinkBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 








//@todo more elegant error handling
function LinkBlockContent(param) {
    var block = param.block, plate = param.plate;
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.theme;
    });
    var isCurrentSession = plate.sessionManager.observe(function(state) {
        return state.isCurrentSession;
    });
    var linkEmbedType = block.observe(function(state) {
        return state.linkEmbedType;
    }); //@nit we probably don't need to observe these
    var url = block.observe(function(state) {
        return state.url;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLinkBlockContent */.G, {
        children: function() {
            switch(linkEmbedType){
                case dist.LinkEmbedType.Twitter:
                    if (!block.getTweetId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link ",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterEmbed, {
                        tweetId: block.getTweetId,
                        theme: theme,
                        disableMouse: isCurrentSession
                    });
                case dist.LinkEmbedType.Youtube:
                    if (!block.getYoutubeVideoId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link ",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeEmbed, {
                        youtubeId: block.getYoutubeVideoId,
                        disableMouse: isCurrentSession
                    });
                case dist.LinkEmbedType.Spotify:
                    if (!block.getSpotifyEmbedId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link ",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpotifyEmbed, {
                        embedId: block.getSpotifyEmbedId,
                        blockId: block.snapshot.id,
                        disableMouse: isCurrentSession
                    });
                case dist.LinkEmbedType.Instagram:
                    if (!block.getInstagramEmbedId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link ",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramEmbed, {
                        embedId: block.getInstagramEmbedId,
                        disableMouse: isCurrentSession
                    });
                case dist.LinkEmbedType.Other:
                    console.error("Hit 'other' in link block switch statement. This is not implemented yet.");
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link ",
                            url
                        ]
                    });
            }
        }()
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/SLinkBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 








function SLinkBlockContent(param) {
    var block = param.block;
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.theme;
    });
    var linkEmbedType = block.snapshot.linkEmbedType;
    var url = block.snapshot.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLinkBlockContent */.G, {
        children: function() {
            switch(linkEmbedType){
                case dist.LinkEmbedType.Twitter:
                    if (!block.getTweetId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link $",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterEmbed, {
                        tweetId: block.getTweetId,
                        theme: theme,
                        disableMouse: false
                    });
                case dist.LinkEmbedType.Youtube:
                    if (!block.getYoutubeVideoId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link $",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeEmbed, {
                        youtubeId: block.getYoutubeVideoId,
                        disableMouse: false
                    });
                case dist.LinkEmbedType.Spotify:
                    if (!block.getSpotifyEmbedId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link $",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpotifyEmbed, {
                        embedId: block.getSpotifyEmbedId,
                        blockId: block.snapshot.id,
                        disableMouse: false
                    });
                case dist.LinkEmbedType.Instagram:
                    if (!block.getInstagramEmbedId) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link $",
                            url
                        ]
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InstagramEmbed, {
                        embedId: block.getInstagramEmbedId,
                        disableMouse: false
                    });
                case dist.LinkEmbedType.Other:
                    console.error("Hit 'other' in link block switch statement. This is not implemented yet.");
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorBlock/* ErrorBlock */.i, {
                        children: [
                            "Link Embed Failed to Render link $",
                            url
                        ]
                    });
            }
        }()
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/LinkBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



/***/ }),

/***/ 247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ StyledLinkBlockContent; },
/* harmony export */   "y": function() { return /* binding */ StyledIframe; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  border: 0px;\n  pointer-events: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledLinkBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-e9f78c13-0"
})(_templateObject());
var StyledIframe = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    componentId: "sc-e9f78c13-1"
})(_templateObject1(), function(param) {
    var disableMouse = param.disableMouse;
    return disableMouse ? "none" : "auto";
});


/***/ }),

/***/ 63660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ PDFBlock; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(86524);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/FileBlock/StandardFilePreview.tsx
var StandardFilePreview = __webpack_require__(16769);
// EXTERNAL MODULE: ./src/components/Block/BlockTypes/LinkBlock/styles.ts
var styles = __webpack_require__(247);
;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/PDFBlock/PDFBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function PDFBlock(param) {
    var block = param.block, disableMouse = param.disableMouse;
    var isScreenshotter = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.isScreenshotter;
    });
    return isScreenshotter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StandardFilePreview/* StandardFilePreview */.C, {
        block: block
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledIframe */.y, {
        src: block.pdfEmbedURL,
        "allow-downloads": false,
        disableMouse: disableMouse
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/PDFBlock/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 33237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ StyledTextBlockContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49516);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledTextBlockContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlockContent */ .cy).withConfig({
    componentId: "sc-6f893ca-0"
})(_templateObject());


/***/ }),

/***/ 70967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ FileStatusWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
// EXTERNAL MODULE: ./src/components/Block/Placeholders/ErrorBlock.tsx
var ErrorBlock = __webpack_require__(58369);
// EXTERNAL MODULE: ./src/components/Block/styles.ts
var styles = __webpack_require__(49516);
// EXTERNAL MODULE: ./src/components/Layout/Typography.tsx
var Typography = __webpack_require__(5427);
;// CONCATENATED MODULE: ./src/components/Block/Placeholders/UploadProgress.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function UploadProgress(param) {
    var uploadPercent = param.uploadPercent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledLoadingMessage */.VX, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Uploading..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Mono */.f, {
                children: uploadPercent && "".concat(Math.min(uploadPercent, 99).toFixed(0), "%")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Block/BlockTypes/utility/FileStatusWrapper.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




function FileStatusWrapper(param) {
    var block = param.block, children = param.children, fallbackComponent = param.fallbackComponent;
    var fileStatus = block.observe(function(state) {
        return state.fileStatus;
    });
    var uploadPercent = block.observe(function(state) {
        return state.uploadPercent;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: function() {
            switch(fileStatus){
                case dist.FileStatus.Uploaded:
                    return children;
                case dist.FileStatus.Uploading:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadProgress, {
                        uploadPercent: uploadPercent
                    });
                case dist.FileStatus.Failed:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        msg: "".concat(block.snapshot.type, " not found")
                    });
                case dist.FileStatus.None:
                    return fallbackComponent || /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        msg: "".concat(block.snapshot.type, " not found")
                    });
                default:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* ErrorBlock */.i, {
                        msg: "".concat(block.snapshot.type, " not found")
                    });
            }
        }()
    });
}


/***/ }),

/***/ 58369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ErrorBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44725);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49516);
/* harmony import */ var src_components_Layout_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5427);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function ErrorBlock(param) {
    var msg = param.msg, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledLoadingMessage */ .VX, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Layout_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Mono */ .f, {
                children: "Error"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: msg
            }),
            children
        ]
    });
}


/***/ }),

/***/ 67864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MessageBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44725);
/* harmony import */ var src_components_Block_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49516);
/* harmony import */ var src_components_Layout_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5427);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function MessageBlock(param) {
    var msg = param.msg, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Block_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledLoadingMessage */ .VX, {
        children: [
            msg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Layout_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Mono */ .f, {
                children: msg
            }),
            children
        ]
    });
}


/***/ }),

/***/ 49516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VX": function() { return /* binding */ StyledLoadingMessage; },
/* harmony export */   "cy": function() { return /* binding */ BaseBlockContent; },
/* harmony export */   "oy": function() { return /* binding */ BlockContentContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48876);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: calc(100% - ",
        "px); // don't love this\n  flex-grow: 1;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background: ",
        ";\n  outline: ",
        ";\n  border-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: ",
        ";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  font-family: "Inter", sans-serif;\n  font-size: 16px;\n  color: ',
        ";\n  user-select: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


/* ----------------- Block Content ------------------ */ /**
 * Base style that wraps every block type with a like TextBlockContent, ImageBlockContent, etc.
 */ var BaseBlockContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d58d24ec-0"
})(_templateObject(), src_lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .BLOCK_TOPBAR_HEIGHT */ .aU);
var BlockContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d58d24ec-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var shouldScrollToBlock = param.shouldScrollToBlock;
    return shouldScrollToBlock ? "auto" : "";
}, function(param) {
    var theme = param.theme, isScreenshotter = param.isScreenshotter;
    return "".concat(isScreenshotter ? "5" : "1", "px solid ").concat(theme.block.border);
}, function(param) {
    var boxShadow = param.boxShadow, theme = param.theme;
    return boxShadow && "10px 10px ".concat(theme.subtleContrast);
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.block.border);
});
var StyledLoadingMessage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d58d24ec-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});


/***/ }),

/***/ 41358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ DrilledView; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(61253);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(40974);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
// EXTERNAL MODULE: ./src/app/globalStyles.ts
var globalStyles = __webpack_require__(458);
// EXTERNAL MODULE: ./src/classes/api/index.ts + 5 modules
var api = __webpack_require__(54411);
// EXTERNAL MODULE: ./src/classes/utilities/StyleConstants.ts
var StyleConstants = __webpack_require__(47219);
// EXTERNAL MODULE: ./src/components/Block/BlockContent/SBlockContent.tsx + 5 modules
var SBlockContent = __webpack_require__(84691);
;// CONCATENATED MODULE: ./src/components/DrilledView/BigBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  border: ",
        ";\n  flex-shrink: 1;\n  object-fit: contain; // tells images to get as big as they can without changing their aspect ratio\n  display: flex;\n  justify-content: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n    min-height: 75%;\n    padding: 0;\n    margin-top: 50px;\n    margin-bottom: 50px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function BigBlock(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBigBlock, {
        id: "cy-big-block",
        style: StyleConstants/* StyleConstants.getDrilledViewStyles */.P.getDrilledViewStyles(block),
        isImageBlock: block.snapshot.type === dist.BlockType.Image,
        // @todo why is this here?
        onClick: function(e) {
            return block.snapshot.type !== dist.BlockType.Image && e.stopPropagation();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SBlockContent/* SBlockContent */.f, {
            block: block
        })
    });
}
var StyledBigBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12a22864-0"
})(_templateObject(), function(param) {
    var isImageBlock = param.isImageBlock, theme = param.theme, isPageWindow = param.isPageWindow;
    return !isImageBlock && !isPageWindow ? theme.background : "transparent";
}, function(param) {
    var theme = param.theme, isImageBlock = param.isImageBlock, isPageWindow = param.isPageWindow;
    return !isImageBlock && !isPageWindow && "1px solid ".concat(theme.block.border);
}, globalStyles/* DEVICE.small */.T.small);

;// CONCATENATED MODULE: ./src/components/Block/DrilledButtons/DrilledButton.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function DrilledButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n          background-color: ",
        ";\n          &:active {\n            color: ",
        ";\n          }\n        "
    ]);
    DrilledButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n          &:hover {\n            color: ",
        ";\n            background-color: ",
        ";\n          }\n          &:active {\n            color: ",
        ";\n            background-color: ",
        ";\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 30px;\n  flex-grow: 1;\n  max-width: 48%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: ",
        ";\n  cursor: pointer;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



function DrilledButton(param) {
    var handleClick = param.handleClick, children = param.children, isSelected = param.isSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDrilledButton, {
        onClick: handleClick,
        isSelected: isSelected,
        children: children
    });
};
var StyledDrilledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-18924fe1-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.subtleContrast);
}, function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return isSelected ? (0,styled_components_browser_esm/* css */.iv)(DrilledButton_templateObject(), theme.iconButton.selected.color, theme.iconButton.selected.backgroundColor, theme.iconButton.selected.activeColor) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.iconButton.color, theme.iconButton.hoverColor, theme.button.hover, theme.iconButton.activeColor, theme.iconButton.activeBackgroundColor);
});

// EXTERNAL MODULE: ./src/components/Shared/ConnectMenu/index.ts + 3 modules
var ConnectMenu = __webpack_require__(71891);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
;// CONCATENATED MODULE: ./src/components/Block/DrilledButtons/DrilledButtons.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function DrilledButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    DrilledButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function DrilledButtons(param) {
    var block = param.block;
    var isLiked = block.observe(function(state) {
        return state.isLiked;
    });
    var ref = (0,react.useState)(false), connectMenuOpen = ref[0], setConnectMenuOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrilledButtonsWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DrilledButton, {
                handleClick: function() {
                    return block.like();
                },
                isSelected: isLiked,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Like */.mN, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrilledButton, {
                handleClick: function() {
                    return setConnectMenuOpen(true);
                },
                isSelected: connectMenuOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Connect */.lj, {}),
                    connectMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectMenu/* ConnectMenu */.S, {
                        block: block,
                        plate: null,
                        closeMenu: function() {
                            return setConnectMenuOpen(false);
                        },
                        blockMouseEvents: true
                    })
                ]
            })
        ]
    });
}
var DrilledButtonsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f009042f-0"
})(DrilledButtons_templateObject());

;// CONCATENATED MODULE: ./src/components/Block/DrilledButtons/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/Sections/Actions.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function Actions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  user-select: none;\n  margin-bottom: 6px;\n  :hover {\n    color: ",
        ";\n  }\n  cursor: pointer;\n"
    ]);
    Actions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Actions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: inherit;\n"
    ]);
    Actions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function Actions(param) {
    var block = param.block;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: function() {
            switch(block.snapshot.type){
                case dist.BlockType.Text:
                    var textBlock = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExternalLink, {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: textBlock.searchLink,
                                    children: "Search Google"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                                onClick: function() {
                                    return textBlock.copyText();
                                },
                                children: "Copy Text"
                            })
                        ]
                    });
                case dist.BlockType.Image:
                    var imageBlock = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExternalLink, {
                                    href: imageBlock.downloadLink || "",
                                    download: true,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Download"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExternalLink, {
                                    href: imageBlock.getImageLinkForSize("biggest"),
                                    target: "_blank",
                                    children: "Open in New Tab"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExternalLink, {
                                    href: imageBlock.searchLink || "",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Reverse Image Search"
                                })
                            })
                        ]
                    });
                case dist.BlockType.File:
                    var fileBlock = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExternalLink, {
                            href: fileBlock.fileURL,
                            download: true,
                            target: "_self",
                            children: [
                                "Download ",
                                fileBlock.readableFileSize
                            ]
                        })
                    });
                case dist.BlockType.Link:
                    var linkBlock = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExternalLink, {
                            href: linkBlock.snapshot.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Open in New Tab"
                        })
                    });
                case dist.BlockType.Code:
                    var codeBlock = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                        onClick: function() {
                            return codeBlock.copyText();
                        },
                        children: "Copy Text"
                    });
                case dist.BlockType.Color:
                    var colorBlock = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                        onClick: function() {
                            return colorBlock.copyHex();
                        },
                        children: "Copy Hex"
                    });
                case dist.BlockType.PlateWindow:
                    var plateWindow = block;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAction, {
                        onClick: function() {
                            return plateWindow.openInNewTab();
                        },
                        children: "Open in New Tab"
                    });
                default:
                    return null;
            }
        }()
    });
}
var StyledAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-541590c5-0"
})(Actions_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.text.url;
});
var StyledExternalLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-541590c5-1"
})(Actions_templateObject1());

// EXTERNAL MODULE: ./src/components/DrilledView/SidePanel/Sections/Attributes.tsx + 3 modules
var Attributes = __webpack_require__(82236);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/index.ts
var PageThumbnail = __webpack_require__(12539);
;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/Sections/RelatedPages.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function RelatedPages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"
    ]);
    RelatedPages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function RelatedPages(param) {
    var plates = param.plates;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: plates.map(function(plate) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageThumbnail/* PageThumbnail */.G, {
                plate: plate,
                wrapperStyles: {
                    width: "48%",
                    marginBottom: "15px"
                }
            }, plate.snapshot.id);
        })
    });
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-553fcb8c-0"
})(RelatedPages_templateObject());

;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/Sections/SidePanelSection.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SidePanelSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  user-select: none;\n"
    ]);
    SidePanelSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SidePanelSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n"
    ]);
    SidePanelSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function SidePanelSection(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionTitle, {
                children: title
            }),
            children
        ]
    });
}
var StyledSectionTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-b76b4aa4-0"
})(SidePanelSection_templateObject());
var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b76b4aa4-1"
})(SidePanelSection_templateObject1());

;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/SidePanel.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SidePanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 300px;\n  flex-shrink: 0;\n  height: 100%;\n  background-color: ",
        ';\n  padding: 25px;\n  font-family: "IBM Plex Mono";\n  display: flex;\n  flex-direction: column;\n  color: ',
        ";\n  overflow-y: auto;\n  box-shadow: 10px 10px #e1e1e1;\n  box-shadow: ",
        ";\n  margin-left: 20px;\n  border: ",
        ";\n  @media (max-width: ",
        ") {\n    height: unset;\n    width: 90%;\n    margin-bottom: 50px;\n    margin-left: 0px;\n  }\n"
    ]);
    SidePanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









// side panel of drilled view
function SidePanel(param) {
    var block = param.block, owner = param.owner, likedBy = param.likedBy, plates = param.plates;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSidePanel, {
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanelSection, {
                title: "<attributes>",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Attributes/* BlockAttributes */.k, {
                    block: block,
                    blockOwner: owner,
                    likedBy: likedBy
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanelSection, {
                title: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DrilledButtons, {
                    block: block
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanelSection, {
                title: "<plates>",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedPages, {
                    plates: plates
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanelSection, {
                title: "<actions>",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                    block: block
                })
            })
        ]
    });
}
var StyledSidePanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9baffb4f-0"
})(SidePanel_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.text.default;
}, function(param) {
    var theme = param.theme;
    return "10px 10px ".concat(theme.subtleContrast);
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, globalStyles/* DEVICE.small */.T.small);

// EXTERNAL MODULE: ./src/components/Layout/LoadingWrapper.tsx + 2 modules
var LoadingWrapper = __webpack_require__(26080);
// EXTERNAL MODULE: ./src/lib/types.ts
var types = __webpack_require__(45085);
;// CONCATENATED MODULE: ./src/components/DrilledView/DrilledBlock.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 






function DrilledBlock(param) {
    var blockId = param.blockId;
    var ref = (0,react.useState)(types/* LoadingStatus.Idle */.Q.Idle), loadingStatus = ref[0], setLoadingStatus = ref[1];
    var ref1 = (0,react.useState)(null), data = ref1[0], setData = ref1[1];
    (0,react.useEffect)(function() {
        api/* API.blocks.getDrilled */.b.blocks.getDrilled(blockId).then(function(res) {
            setData(res);
            setLoadingStatus(types/* LoadingStatus.Succeeded */.Q.Succeeded);
        }).catch(function() {
            return setLoadingStatus(types/* LoadingStatus.Failed */.Q.Failed);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper/* LoadingWrapper */.u, {
        status: loadingStatus,
        loadingType: LoadingWrapper/* LoadingType.Inline */.F.Inline,
        children: data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BigBlock, {
                    block: data.block
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanel, {
                    block: data.block,
                    likedBy: data.likedBy,
                    owner: data.owner,
                    plates: data.plates
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/Block/BlockTypes/EmbeddedPlate/SEmbeddedPlate.tsx
var SEmbeddedPlate = __webpack_require__(35182);
;// CONCATENATED MODULE: ./src/components/DrilledView/DrilledPlate.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 







function DrilledPlate(param) {
    var plateId = param.plateId;
    var ref = (0,react.useState)(types/* LoadingStatus.Idle */.Q.Idle), loadingStatus = ref[0], setLoadingStatus = ref[1];
    var ref1 = (0,react.useState)(null), data = ref1[0], setData = ref1[1];
    (0,react.useEffect)(function() {
        api/* API.plates.getDrilled */.b.plates.getDrilled(plateId).then(function(res) {
            setData(res);
            setLoadingStatus(types/* LoadingStatus.Succeeded */.Q.Succeeded);
        }).catch(function() {
            return setLoadingStatus(types/* LoadingStatus.Failed */.Q.Failed);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper/* LoadingWrapper */.u, {
        status: loadingStatus,
        loadingType: LoadingWrapper/* LoadingType.Inline */.F.Inline,
        children: data && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBigBlock, {
                id: "cy-big-block",
                style: StyleConstants/* StyleConstants.defaultDrilledBlockStyles */.P.defaultDrilledBlockStyles,
                isPageWindow: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SEmbeddedPlate/* SEmbeddedPlate */.o, {
                    plate: data.plate
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/Hotkeys/hotkeys.ts
var hotkeys = __webpack_require__(63546);
// EXTERNAL MODULE: ./src/components/UI/Buttons/index.ts
var Buttons = __webpack_require__(75640);
// EXTERNAL MODULE: ./src/lib/hooks/useHotkey.ts
var useHotkey = __webpack_require__(51367);
;// CONCATENATED MODULE: ./src/components/DrilledView/DrilledView.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function DrilledView_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  line-height: 1.15;\n  font-family: "Inter";\n  background: rgba(131, 131, 131, 0.304);\n  // add a blur to the background\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  overflow: scroll;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: ',
        ";\n  padding: 20px;\n  @media (max-width: ",
        ") {\n    padding: 0;\n  }\n"
    ]);
    DrilledView_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DrilledView_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 20px;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n  }\n"
    ]);
    DrilledView_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DrilledView_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  left: 15px;\n  width: 30px;\n  height: 30px;\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 999;\n  &:hover {\n    /* background-color: rgba(0, 0, 0, 0.3); */\n    color: ",
        ";\n  }\n"
    ]);
    DrilledView_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












function DrilledView() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, blockId = _query.blockId, pageId = _query.pageId;
    // strip the blockId/pageId query param and return back to whatever the underlying
    // page is
    var handleClose = function() {
        if (router.asPath.includes("?blockId=".concat(blockId))) {
            router.replace(router.asPath.replace("?blockId=".concat(blockId), ""));
        } else if (router.asPath.includes("?pageId=".concat(pageId))) {
            router.replace(router.asPath.replace("?pageId=".concat(pageId), ""));
        }
    };
    (0,useHotkey/* useHotkey */.P)(hotkeys/* HOTKEYS.ESCAPE */.LM.ESCAPE, handleClose);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundOverlay, {
        onClick: handleClose,
        id: "cy-drilled-background-overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrilledView_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseWrapper, {
                    onClick: function(e) {
                        e.stopPropagation();
                        handleClose();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* XButtonSVG */.TW, {})
                }),
                blockId && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrilledBlock, {
                    blockId: blockId
                }),
                pageId && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrilledPlate, {
                    plateId: pageId
                })
            ]
        })
    });
}
var BackgroundOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9dcca4fa-0"
})(DrilledView_templateObject(), dist.Layer.OVERLAY, globalStyles/* DEVICE.small */.T.small);
var DrilledView_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9dcca4fa-1"
})(DrilledView_templateObject1(), globalStyles/* DEVICE.small */.T.small);
var CloseWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9dcca4fa-2"
})(DrilledView_templateObject2(), lib/* isElectron */.d ? "45px" : "20px", function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return theme.background;
});


/***/ }),

/***/ 82236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ BlockAttributes; },
  "TD": function() { return /* binding */ TD; }
});

// UNUSED EXPORTS: PlateAttributes

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(85588);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(32686);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__(45231);
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var app_useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/classes/block/block-types/index.ts + 10 modules
var block_types = __webpack_require__(20265);
;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/Sections/ViennaTag.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  user-select: none;\n  white-space: normal;\n  cursor: default;\n  color: ",
        ";\n  background-color: ",
        ";\n  padding-top: 3px;\n  padding-bottom: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: 11px;\n  line-height: 14px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  position: relative;\n  max-width: 125px;\n  overflow-wrap: break-word;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 13px;\n  height: 13px;\n  background-color: ",
        ";\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  cursor: pointer;\n  border: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &:hover {\n    background-color: ",
        ";\n  }\n  &:active {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  width: 7px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function ViennaTag(param) {
    var tag = param.tag, removeTag = param.removeTag, editable = param.editable;
    var ref = (0,react.useState)(false), hovering = ref[0], setHovering = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledViennaTag, {
        onMouseEnter: function() {
            return setHovering(true);
        },
        onMouseLeave: function() {
            return setHovering(false);
        },
        children: [
            tag,
            hovering && editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDeleteButton, {
                onClick: function() {
                    return removeTag(tag);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteIcon, {})
            })
        ]
    });
}
var StyledViennaTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-82c85771-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.highContrast;
}, function(param) {
    var theme = param.theme;
    return theme.primary;
});
var StyledDeleteButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-82c85771-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, function(param) {
    var theme = param.theme;
    return theme.button.hover;
}, function(param) {
    var theme = param.theme;
    return theme.button.active;
});
var DeleteIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82c85771-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.primary;
});

;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/Sections/ImageAttributes.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function ImageAttributes_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    ImageAttributes_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function ImageAttributes(param) {
    var block = param.block;
    var tags = block.observe(function(state) {
        return state.tags;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                isFirstColumn: true,
                children: "<tags>"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsWrapper, {
                    children: tags.map(function(tag, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViennaTag, {
                            tag: tag.tag,
                            removeTag: function() {},
                            editable: false
                        }, index);
                    })
                })
            })
        ]
    });
}
var TagsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e82dbb3b-0"
})(ImageAttributes_templateObject());

// EXTERNAL MODULE: ./src/components/Shared/User/Username.tsx + 2 modules
var User_Username = __webpack_require__(67272);
;// CONCATENATED MODULE: ./src/components/Shared/Likes/LikedBy.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function LikedBy_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n  max-height: 180px;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 10px 14px;\n"
    ]);
    LikedBy_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function LikedBy_LikedBy(param) {
    var users = param.users;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LikedByWrapper, {
        children: users.map(function(user) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(User_Username/* Username */.R, {
                user: user,
                style: {
                    padding: "2px"
                }
            }, user.snapshot.id);
        })
    });
}
var LikedByWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13e0071-0"
})(LikedBy_templateObject());

;// CONCATENATED MODULE: ./src/components/DrilledView/SidePanel/Sections/Attributes.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function Attributes_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-collapse: collapse;\n  font-size: 12px;\n  user-select: none;\n  max-width: 100%;\n"
    ]);
    Attributes_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Attributes_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: ",
        ";\n  padding: 10px 14px;\n  font-weight: ",
        ";\n  line-height: 12px;\n  white-space: nowrap;\n  overflow-x: auto;\n  height: 42px;\n  max-width: 154px;\n"
    ]);
    Attributes_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










dayjs_min_default().extend((relativeTime_default()));
function BlockAttributes(param) {
    var block = param.block, blockOwner = param.blockOwner, likedBy = param.likedBy;
    var currentUser = (0,app_useCurrentUser/* useCurrentUser */.x)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributesTable, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                            isFirstColumn: true,
                            children: "<by>"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(User_Username/* Username */.R, {
                                user: blockOwner
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                            isFirstColumn: true,
                            children: "<time>"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                            children: dayjs_min_default()(block.snapshot.createdAt).fromNow()
                        })
                    ]
                }),
                (0,_instanceof/* default */.Z)(block, block_types/* ImageBlock */.r8) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageAttributes, {
                    block: block
                }),
                currentUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                            isFirstColumn: true,
                            children: "<likedBy>"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TD, {
                            style: {
                                padding: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LikedBy_LikedBy, {
                                users: likedBy
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function PlateAttributes(param) {
    var plate = param.plate, blockOwner = param.blockOwner, likedBy = param.likedBy;
    var currentUser = useCurrentUser();
    return /*#__PURE__*/ _jsx(AttributesTable, {
        children: /*#__PURE__*/ _jsxs("tbody", {
            children: [
                /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx(TD, {
                            isFirstColumn: true,
                            children: "<by>"
                        }),
                        /*#__PURE__*/ _jsx(TD, {
                            children: /*#__PURE__*/ _jsx(Username, {
                                user: blockOwner
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx(TD, {
                            isFirstColumn: true,
                            children: "<time>"
                        }),
                        /*#__PURE__*/ _jsx(TD, {
                            children: dayjs(plate.snapshot.createdAt).fromNow()
                        })
                    ]
                }),
                currentUser && /*#__PURE__*/ _jsxs("tr", {
                    children: [
                        /*#__PURE__*/ _jsx(TD, {
                            isFirstColumn: true,
                            children: "<likedBy>"
                        }),
                        /*#__PURE__*/ _jsx(TD, {
                            style: {
                                padding: 0
                            },
                            children: /*#__PURE__*/ _jsx(LikedBy, {
                                users: likedBy
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var AttributesTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-39d66883-0"
})(Attributes_templateObject());
var TD = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-39d66883-1"
})(Attributes_templateObject1(), function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, function(param) {
    var isFirstColumn = param.isFirstColumn;
    return isFirstColumn ? "bold" : "normal";
}); // const StyledTextArea = styled.textarea`
 //   width: 100%;
 //   font-size: inherit;
 //   font-family: inherit;
 //   color: ${({ theme }) => theme.text.default};
 //   background-color: inherit;
 //   resize: none;
 //   border: none;
 //   outline: none;
 //   ::-webkit-scrollbar {
 //     display: none;
 //   }
 //   ::placeholder {
 //     color: ${({ theme }) => theme.text.subtle};
 //   }
 // `;
 // const StyledInput = styled.input`
 //   color: ${({ theme }) => theme.text.default};
 //   background-color: ${({ theme }) => theme.background};
 //   font-family: "IBM Plex Mono";
 //   padding: 10px;
 //   font-size: 11px;
 //   border: ${({ theme }) => `2px solid ${theme.block.border}`};
 //   height: 30px;
 //   outline: none;
 //   margin-right: 24px;
 //   &:focus {
 //     border-color: ${({ theme }) => theme.primary};
 //   }
 //   ::placeholder {
 //     color: ${({ theme }) => theme.text.subtle};
 //     user-select: none;
 //   }
 // `;


/***/ }),

/***/ 5427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PageHeading; },
/* harmony export */   "f": function() { return /* binding */ Mono; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "IBM Plex Mono";\n  font-size: 20px;\n  /* line-height: 20px; */\n  font-weight: 500;\n  margin-right: 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  display: flex;\n  flex-direction: "row";\n  align-items: center;\n  color: ',
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "IBM Plex Mono";\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var PageHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-4e096f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var Mono = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4e096f-1"
})(_templateObject1());


/***/ }),

/***/ 72423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rb": function() { return /* binding */ SigninWithEmailButton; },
/* harmony export */   "Xk": function() { return /* binding */ OrDivider; },
/* harmony export */   "a1": function() { return /* binding */ IconWrapper; },
/* harmony export */   "gj": function() { return /* binding */ ChangeSignupMethodButton; },
/* harmony export */   "nG": function() { return /* binding */ UrbitButton; },
/* harmony export */   "ss": function() { return /* binding */ SignupMethodButton; },
/* harmony export */   "t": function() { return /* binding */ NeedHelpLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14129);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48876);
/* harmony import */ var src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4048);
/* harmony import */ var src_components_UI_Buttons_ButtonPrimitives__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70854);
/* harmony import */ var src_components_UI_Links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47209);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 300px;\n  margin-bottom: 15px;\n  width: 100%;\n  flex-shrink: 0;\n  display: flex;\n  height: 30px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-left: 5px;\n  color: #888;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var SignupMethodButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(src_components_UI_Buttons_ButtonPrimitives__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx).withConfig({
    componentId: "sc-9edbc824-0"
})(_templateObject());
var ChangeSignupMethodButton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: {
            marginTop: "20px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AppRoutes.Register */ .$w.Register,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChangeSignupMethodLink, {
                children: "Change signup method"
            })
        })
    });
};
var SigninWithEmailButton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: {
            marginTop: "20px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AppRoutes.SigninEmail */ .$w.SigninEmail,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChangeSignupMethodLink, {
                children: "Signin with email"
            })
        })
    });
};
var ChangeSignupMethodLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_6__/* .StyledLink */ .Fg).withConfig({
    componentId: "sc-9edbc824-1"
})(_templateObject1());
var NeedHelpLink = function(param) {
    var textOverride = param.textOverride, styles = param.styles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            paddingTop: "8px"
        }, styles || {}),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "".concat(src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AppRoutes.BlogSignupWithUrbit */ .$w.BlogSignupWithUrbit, "#step-by-step"),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ChangeSignupMethodLink, {
                target: "_blank",
                children: [
                    " ",
                    textOverride || "Signup with Urbit Instructions"
                ]
            })
        })
    });
};
var UrbitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(src_components_UI_Buttons_ButtonPrimitives__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx).withConfig({
    componentId: "sc-9edbc824-2"
})(_templateObject2());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9edbc824-3"
})(_templateObject3());
function OrDivider(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Login_Styles__WEBPACK_IMPORTED_MODULE_4__/* .EndOfFormText */ .Qx, {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            fontSize: "14px",
            marginTop: "10px",
            marginBottom: "15px"
        }, style),
        alwaysLightMode: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            style: {
                display: "flex",
                justifyContent: "center"
            },
            children: "— OR —"
        })
    });
}


/***/ }),

/***/ 57459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ ConnectButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ./src/components/Shared/ConnectMenu/index.ts + 3 modules
var ConnectMenu = __webpack_require__(71891);
// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/IconButton.tsx
var IconButton = __webpack_require__(20195);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
;// CONCATENATED MODULE: ./src/components/UI/Buttons/IconButtons/Connect/Connect.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




function ConnectButton(param) {
    var block = param.block, plate = param.plate, menuOpen = param.menuOpen, setMenuOpen = param.setMenuOpen, id = param.id, styles = param.styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                isSelected: menuOpen,
                handleClick: function() {
                    return setMenuOpen(true);
                },
                tooltipText: "Add to plate",
                id: id,
                styles: styles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Connect */.lj, {})
            }),
            menuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectMenu/* ConnectMenu */.S, {
                block: block,
                plate: plate,
                closeMenu: function() {
                    return setMenuOpen(false);
                },
                blockMouseEvents: true
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/UI/Buttons/IconButtons/Connect/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 20195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48876);
/* harmony import */ var src_components_UI_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23732);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: ",
        ";\n          background-color: ",
        ";\n          &:active {\n            color: ",
        ";\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: ",
        ";\n          &:hover {\n            color: ",
        ";\n            background-color: ",
        ";\n          }\n          &:active {\n            color: ",
        ";\n            background-color: ",
        ";\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  cursor: pointer;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




function IconButton(param) {
    var isSelected = param.isSelected, handleClick = param.handleClick, children = param.children, tooltipText = param.tooltipText, id = param.id, styles = param.styles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
        isSelected: isSelected,
        onClick: handleClick,
        id: id,
        style: styles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* .Tooltip */ .u, {
            tooltipText: tooltipText,
            children: children
        })
    });
}
var StyledIconButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-30e919e9-0"
})(_templateObject2(), function(param) {
    var theme = param.theme, isSelected = param.isSelected;
    return isSelected ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), theme.iconButton.selected.color, theme.iconButton.selected.backgroundColor, theme.iconButton.selected.activeColor) : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject1(), theme.iconButton.color, theme.iconButton.hoverColor, theme.button.hover, theme.iconButton.activeColor, theme.iconButton.activeBackgroundColor);
});


/***/ }),

/***/ 69397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ Like; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ./src/components/UI/Buttons/IconButtons/IconButton.tsx
var IconButton = __webpack_require__(20195);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
;// CONCATENATED MODULE: ./src/components/UI/Buttons/IconButtons/Like/Like.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function Like(param) {
    var like = param.like, isLiked = param.isLiked, styles = param.styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
        isSelected: isLiked,
        handleClick: function() {
            return like();
        },
        tooltipText: isLiked ? "Unlike" : "Like",
        id: "cy-block-like-button",
        styles: styles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Like */.mN, {})
    });
}

;// CONCATENATED MODULE: ./src/components/UI/Buttons/IconButtons/Like/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 79868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* reexport */ ContextMenu; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(85588);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(40974);
// EXTERNAL MODULE: ./src/app/useCurrentUser.ts
var useCurrentUser = __webpack_require__(29635);
// EXTERNAL MODULE: ./src/classes/block/block-types/index.ts + 10 modules
var block_types = __webpack_require__(20265);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
// EXTERNAL MODULE: ./src/components/UI/Menus/MenuItem/MenuBreak.tsx
var MenuBreak = __webpack_require__(22639);
// EXTERNAL MODULE: ./src/components/UI/Menus/MenuItem/MenuItem.tsx
var MenuItem = __webpack_require__(57608);
;// CONCATENATED MODULE: ./src/components/Block/ContextMenu/ImageMenuItems.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




function ImageMenuItems(param) {
    var block = param.block;
    var imageFit = block.observe(function(state) {
        return state.imageFit;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBreak/* MenuBreak */.D, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                handleClick: function() {
                    return block.createCaption();
                },
                children: "Add Caption"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                handleClick: function() {
                    return block.changeImageFit();
                },
                checkmarked: imageFit === dist.ImageFit.Cover,
                children: "Fill Block"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Shared/ConnectMenu/index.ts + 3 modules
var ConnectMenu = __webpack_require__(71891);
// EXTERNAL MODULE: ./src/components/UI/Menus/Menu.tsx
var Menu = __webpack_require__(54871);
;// CONCATENATED MODULE: ./src/components/Block/ContextMenu/ContextMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 










function BlockContextMenu(param) {
    var block = param.block, editable = param.editable, anchor = param.anchor, close = param.close;
    var loggedIn = !!(0,useCurrentUser/* useCurrentUser */.x)();
    var isLiked = block.observe(function(state) {
        return state.isLiked;
    });
    // if block window, render context menu for embedded block
    return (0,_instanceof/* default */.Z)(block, block_types/* BlockWindow */.J3) && block.embeddedBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContextMenu, {
        block: block.embeddedBlock,
        editable: editable,
        anchor: anchor,
        close: close
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        anchor: anchor,
        close: close,
        blockMouseEvents: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                handleClick: function() {
                    return block.open();
                },
                children: "Open"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: !lib/* isElectron */.d,
                handleClick: function() {
                    return block.openInNewTab();
                },
                children: "Open in New Tab"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                handleClick: function() {
                    return block.copyLink();
                },
                children: "Copy link"
            }),
            (0,_instanceof/* default */.Z)(block, block_types/* ImageBlock */.r8) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        handleClick: function() {
                            return block.downloadImage();
                        },
                        children: "Download Image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                        handleClick: function() {
                            return block.copyImage();
                        },
                        children: "Copy image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBreak/* MenuBreak */.D, {
                condition: loggedIn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: loggedIn,
                handleClick: function() {
                    return block.like();
                },
                children: isLiked ? "Unlike" : "Like"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: loggedIn,
                hasSubOptions: true,
                hoverComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectMenu/* ConnectMenu */.S, {
                    block: block,
                    plate: null,
                    blockMouseEvents: false
                }),
                children: "Add To Plate"
            }),
            (0,_instanceof/* default */.Z)(block, block_types/* ImageBlock */.r8) && editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageMenuItems, {
                block: block
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Block/ContextMenu/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

// EXTERNAL MODULE: ./src/components/UI/Alert/Alert.tsx
var Alert = __webpack_require__(18638);
;// CONCATENATED MODULE: ./src/components/Plate/ContextMenu/ContextMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 








function PlateContextMenu(param) {
    var plate = param.plate, anchor = param.anchor, close = param.close;
    var currentUser = (0,useCurrentUser/* useCurrentUser */.x)();
    var loggedIn = !!currentUser;
    var ref = (0,react.useState)(false), deleteAlertOpen = ref[0], setDeleteAlertOpen = ref[1];
    var isOwner = plate.observe(function(state) {
        return state.currentUserIsOwner;
    });
    var isLiked = plate.observe(function(state) {
        return state.isLiked;
    });
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    var onDeleteAccept = function() {
        setDeleteAlertOpen(false);
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.deletePlate(plate);
    };
    var handleDelete = function(e) {
        e.stopPropagation();
        setDeleteAlertOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        anchor: anchor,
        close: close,
        blockMouseEvents: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: !lib/* isElectron */.d,
                handleClick: plate.openInNewTab,
                children: "Open in New Tab"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                handleClick: plate.copyLink,
                children: "Copy Link"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBreak/* MenuBreak */.D, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: loggedIn,
                handleClick: function() {
                    return plate.like();
                },
                children: isLiked ? "Unlike" : "Like"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBreak/* MenuBreak */.D, {
                condition: loggedIn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: isOwner,
                handleClick: function() {
                    return plate.changePrivacy();
                },
                children: isPublic ? "Make Private" : "Make Public"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: isOwner,
                handleClick: handleDelete,
                children: "Delete"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* MenuItem */.s, {
                condition: loggedIn,
                hasSubOptions: true,
                hoverComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectMenu/* ConnectMenu */.S, {
                    plate: plate,
                    block: null,
                    blockMouseEvents: false
                }),
                children: "Add To Plate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                type: "question",
                acceptText: "Yes",
                declineText: "No",
                onAccept: onDeleteAccept,
                onDecline: function() {
                    return setDeleteAlertOpen(false);
                },
                isOpen: deleteAlertOpen,
                headerText: "Are you sure you want to delete this plate?",
                bodyText: "Deleting is a permanent action and cannot be undone."
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Plate/ContextMenu/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

;// CONCATENATED MODULE: ./src/components/UI/ContextMenu/ContextMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function ContextMenu(param) {
    var children = param.children, plate = param.plate, block = param.block, editable = param.editable;
    // controls whether and where the menu is shown
    var ref = (0,react.useState)(), position = ref[0], setPosition = ref[1];
    var handleContextMenu = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setPosition({
            top: e.pageY,
            right: e.pageX,
            bottom: e.pageY,
            left: e.pageX
        });
    };
    var closeContextMenu = function() {
        setPosition(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onContextMenu: handleContextMenu,
                children: children
            }),
            position && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    plate && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlateContextMenu, {
                        plate: plate,
                        anchor: position,
                        close: closeContextMenu
                    }),
                    block && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContextMenu, {
                        block: block,
                        editable: editable,
                        anchor: position,
                        close: closeContextMenu
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/UI/ContextMenu/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 68922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ScribeSpinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function ScribeSpinner() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "scribe-spinner"
    });
}


/***/ }),

/***/ 59422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ ViennaEditor; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14129);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(66420);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(5170);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/slate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(92144);
// EXTERNAL MODULE: ../../node_modules/slate-history/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(72845);
// EXTERNAL MODULE: ../../node_modules/slate-react/dist/index.es.js
var slate_react_dist_index_es = __webpack_require__(70517);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/components/Hotkeys/hotkeys.ts
var hotkeys = __webpack_require__(63546);
// EXTERNAL MODULE: ../../node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(7599);
// EXTERNAL MODULE: ../../packages/common/dist/index.js
var dist = __webpack_require__(45869);
;// CONCATENATED MODULE: ./src/components/SlashMenu/SlashOption.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  white-space: nowrap;\n  padding: 14px;\n  background-color: ",
        ";\n  cursor: pointer;\n  scroll-margin: 60px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  width: 20px;\n  margin-right: 17px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var SlashOption = function(param) {
    var option = param.option, selected = param.selected, index = param.index, setSelectedIndex = param.setSelectedIndex, inputType = param.inputType;
    // option ref
    var ref = (0,react.useRef)(null);
    // when selected scroll option into view
    (0,react.useEffect)(function() {
        if (selected && inputType === "keyboard") {
            var optionElement = ref.current;
            if (optionElement) {
                optionElement.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest"
                });
            }
        }
    }, [
        selected
    ]);
    var handleMouseEnter = function() {
        // If input type is mouse, set selected index. If keyboard, do nothing. this prevents the option from being "selected" by
        // mouse when the mouse is hovering over the menu as you try to navigate it with the keyboard
        if (inputType === "mouse") {
            setSelectedIndex(index);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SlashMenuOptionWrapper, {
        $selected: selected,
        ref: ref,
        onMouseEnter: handleMouseEnter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                children: option.icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionName, {
                        children: option.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionDescription, {
                        children: option.description
                    })
                ]
            })
        ]
    });
};
var SlashMenuOptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89c6a43a-0"
})(_templateObject(), function(param) {
    var $selected = param.$selected, theme = param.theme;
    return $selected && theme.subtleContrast;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89c6a43a-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.primary;
});
var OptionInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89c6a43a-2"
})(_templateObject2());
var OptionName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89c6a43a-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.default;
});
var OptionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89c6a43a-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});

;// CONCATENATED MODULE: ./src/components/SlashMenu/lib/helpers.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
//this could use some comments. what exactly is it going on
var positionSlashMenu = function(elementRef) {
    var selection = window.getSelection();
    if (!selection) return null;
    if (selection.rangeCount > 0) {
        var ref, ref1;
        var range = selection.getRangeAt(0);
        var selectionRect = range.endContainer.hasChildNodes() ? (ref = range.endContainer.parentElement) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect() : range.getBoundingClientRect();
        var selectionTop = selectionRect.y;
        var selectionLeft = selectionRect.x;
        var element = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        var parentRect = (ref1 = getPositionedParent(element)) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
        return {
            top: selectionTop - parentRect.y + 20,
            left: selectionLeft - parentRect.x - 2,
            shouldReverse: window.innerWidth - selectionLeft < 250
        };
    }
    return null;
};
var getPositionedParent = function(element) {
    if (!element) {
        return null;
    }
    var positionProperty = window.getComputedStyle(element).getPropertyValue("position");
    if (positionProperty !== "static") {
        return element;
    }
    if (!element.parentElement) return null;
    return getPositionedParent(element.parentElement);
};

;// CONCATENATED MODULE: ./src/components/SlashMenu/SlashMenu.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function SlashMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  // prevents border from showing up as dot when menu has no options left\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  border: ",
        ';\n  font-family: "IBM Plex Mono";\n  font-weight: 600;\n  max-height: 330px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: ',
        ";\n"
    ]);
    SlashMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function SlashMenu(param) {
    var close = param.close, handleSelect = param.handleSelect, displayedOptions = param.displayedOptions, elementRef = param.elementRef, setInputType = param.setInputType, inputType = param.inputType, selectedIndex = param.selectedIndex, setSelectedIndex = param.setSelectedIndex, refocusOnEditor = param.refocusOnEditor;
    var slashMenuRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(positionSlashMenu(elementRef)), position = ref[0];
    (0,esm/* useOnClickOutside */.t$)(slashMenuRef, function() {
        return close();
    });
    return position && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlashMenu, {
        onMouseMove: function() {
            return setInputType("mouse");
        },
        ref: slashMenuRef,
        onClick: function(e) {
            e.preventDefault(); // prevent enter from inserting newline into editor
            handleSelect();
            refocusOnEditor();
        },
        style: {
            top: position.top,
            left: position.shouldReverse ? position.left - 240 : position.left
        },
        children: displayedOptions.map(function(option, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlashOption, {
                option: option,
                selected: selectedIndex === index,
                index: index,
                setSelectedIndex: setSelectedIndex,
                inputType: inputType
            }, option.description);
        })
    });
}
var StyledSlashMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b65ae102-0"
})(SlashMenu_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.primary);
}, dist.Layer.WIN_LAYER);

// EXTERNAL MODULE: ./src/components/ViennaEditor/lib/helpers.ts + 1 modules
var helpers = __webpack_require__(47306);
;// CONCATENATED MODULE: ./src/components/ViennaEditor/lib/hotkeys.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

var HOTKEYS = {
    b: "bold",
    i: "italic",
    u: "underline"
};
var richTextHotkeys = function(editor, e) {
    if ((0,helpers/* hasCommandModifier */.lk)(e)) {
        // if the key corresponds to a key command
        if (HOTKEYS[e.key] !== undefined) {
            e.preventDefault(); // don't insert content into editor
            e.stopPropagation();
            var format = HOTKEYS[e.key]; // grab the format from the hotkeys obj
            helpers/* EnhancedEditor.toggleMark */.Xe.toggleMark(editor, format); // toggle format that corresponds to the hotkey
        }
    }
};
var handleSlashMenuKeydown = function(param) {
    var e = param.e, setInputType = param.setInputType, selectedIndex = param.selectedIndex, setSelectedIndex = param.setSelectedIndex, close = param.close, displayedOptions = param.displayedOptions, selectOption = param.selectOption;
    switch(e.key){
        case "ArrowDown":
            e.preventDefault();
            setInputType("keyboard");
            // increment selected index; loop back to top if going past the last option
            setSelectedIndex(selectedIndex + 1 > displayedOptions.length - 1 ? 0 : selectedIndex + 1);
            break;
        case "ArrowUp":
            e.preventDefault();
            setInputType("keyboard");
            // decrement selected index; loop back to bottom if going past the first option
            setSelectedIndex(selectedIndex - 1 < 0 ? displayedOptions.length - 1 : selectedIndex - 1);
            break;
        case "Enter":
            e.preventDefault(); // prevent enter from inserting newline into editor
            selectOption();
            return {
                handled: true
            };
        case "Escape":
            close(); // close self on escape
            return {
                handled: true
            };
        default:
            break;
    }
    return {
        handled: false
    };
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49839);
;// CONCATENATED MODULE: ./src/components/ViennaEditor/lib/links.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 

var LINK_REGEX = /((http|https):\/\/)?([\w_-]+(?:(?:\.(?!png|jpeg|jpg|gif|pdf|zip|svg|doc|docx|exe)[a-z+_-]+)+))([\w.,@?^=%&:/~+#-()-;]*[\w@?^=%&/~+#-()-])/g;
var EMAIL_REGEX = // eslint-disable-next-line no-control-regex
/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
/**
 * This decorator finds all the links and emails in a node and returns them with either the
 * email or the link flag set to true. This can be used with "Editable" to render the links
 */ var linkAndEmailDecorator = function(param) {
    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), node = _param[0], path = _param[1];
    // the text of the node
    var nodeText = node.text;
    // if no text, return an empty array
    if (!nodeText) return [];
    var emails = findEmailsInText(nodeText);
    var urls = findUrlsInText(nodeText);
    // find the emails to return
    var retEmails = emails.map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), url = _param[0], index = _param[1];
        return {
            anchor: {
                path: path,
                offset: index
            },
            focus: {
                path: path,
                offset: index + url.length
            },
            email: true
        };
    });
    // find the links to return
    var retUrls = urls.map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), url = _param[0], index = _param[1];
        // double check that the url is not an email
        var isEmail = false;
        emails.map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), email = _param[0], emailIndex = _param[1];
            if (emailIndex + email.length > index && emailIndex < index) {
                isEmail = true;
            }
        });
        // if it is an email, don't return it
        if (isEmail) return;
        // if it is not an email, return it
        return {
            anchor: {
                path: path,
                offset: index
            },
            focus: {
                path: path,
                offset: index + url.length
            },
            link: true
        };
    });
    // return all the links and emails (with links filtered for undefined values)
    return (0,_to_consumable_array/* default */.Z)(retUrls.filter(function(url) {
        return url;
    })).concat((0,_to_consumable_array/* default */.Z)(retEmails));
};
// find all the emails in a text
var findEmailsInText = function(text) {
    var emailMatches = text.match(EMAIL_REGEX);
    return emailMatches ? emailMatches.map(function(m) {
        return [
            m.trim(),
            text.indexOf(m.trim())
        ];
    }) : [];
};
// find all the urls in a text
var findUrlsInText = function(text) {
    var linkMatches = text.match(LINK_REGEX);
    return linkMatches ? linkMatches.map(function(m) {
        return [
            m.trim(),
            text.indexOf(m.trim())
        ];
    }) : [];
};

// EXTERNAL MODULE: ./src/lib/hooks/useOnMouseDownOutside.ts
var useOnMouseDownOutside = __webpack_require__(3002);
// EXTERNAL MODULE: ./src/components/UI/Tooltip/index.ts + 60 modules
var Tooltip = __webpack_require__(23732);
;// CONCATENATED MODULE: ./src/components/ViennaEditor/Element.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function Element_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  :hover {\n    text-decoration: underline;\n  }\n  color: ",
        ";\n"
    ]);
    Element_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Element_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-left: ",
        ";\n  padding-left: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    Element_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function Element(props) {
    var attributes = props.attributes, children = props.children, subType = props.subType, readOnly = props.readOnly;
    var element = props.element;
    var renderElement = function() {
        switch(element.type){
            case "bulleted-list":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    style: {
                        paddingLeft: "20px"
                    }
                }, attributes), {
                    children: children
                }));
            case "numbered-list":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    start: element.start
                }, attributes), {
                    style: {
                        paddingLeft: "40px"
                    },
                    children: children
                }));
            case "list-item":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                    children: children
                }));
            default:
                return children;
        }
    };
    if (element.type === "link") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            tooltipText: "Link: ".concat(element.url),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: function() {
                    return window.open(element.url);
                },
                textSubtype: subType || "plain"
            }, attributes), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledElement, {
        $readOnly: readOnly,
        textSubtype: element.type !== "list-item" && subType ? subType : "plain",
        children: renderElement()
    });
}
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad7d6182-0"
})(Element_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.url;
});
var StyledElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ad7d6182-1"
})(Element_templateObject1(), function(param) {
    var textSubtype = param.textSubtype, theme = param.theme;
    return textSubtype === "quote" && "3px solid ".concat(theme.block.border);
}, function(param) {
    var textSubtype = param.textSubtype;
    return textSubtype === "quote" && "10px";
}, function(param) {
    var textSubtype = param.textSubtype;
    return textSubtype === "quote" && "21px";
});

;// CONCATENATED MODULE: ./src/components/ViennaEditor/Leaf.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


function Leaf_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* mark styles */\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-style: ",
        ";\n  text-decoration: ",
        ";\n"
    ]);
    Leaf_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Leaf_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  :hover {\n    text-decoration: underline;\n  }\n  color: ",
        ";\n"
    ]);
    Leaf_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




/**
 * Leaf is a slate term referring to a chunk of text with the same formatting applied
 */ var Leaf = function(props) {
    var children = props.children, attributes = props.attributes;
    var leaf = props.leaf;
    if (leaf.email) {
        children = /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            tooltipText: "Email: ".concat(leaf.text),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return window.location.href = "mailto:".concat(leaf.text);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkStyles, {
                    children: children
                })
            })
        });
    } else if (leaf.link) {
        var validLinkUrl = leaf.text.slice(0, 8) === "https://" || leaf.text.slice(0, 7) === "http://" ? leaf.text : "http://".concat(leaf.text);
        children = /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            tooltipText: "Link: ".concat(typeof leaf.link === "string" ? leaf.link : leaf.text),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return window.open(typeof leaf.link === "string" ? leaf.link : validLinkUrl);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkStyles, {
                    children: children
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLeaf, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        leaf: leaf
    }, attributes), {
        children: children
    }));
};
var StyledLeaf = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fc2a72e0-0"
})(Leaf_templateObject(), function(param) {
    var leaf = param.leaf;
    return leaf.font ? leaf.font : "inherit";
}, function(param) {
    var leaf = param.leaf;
    return leaf.bold ? "bold" : "inherit";
}, function(param) {
    var leaf = param.leaf;
    return leaf.italic ? "italic" : "inherit";
}, function(param) {
    var leaf = param.leaf;
    return leaf.underline ? "underline" : "inherit";
});
var LinkStyles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc2a72e0-1"
})(Leaf_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.url;
});

;// CONCATENATED MODULE: ./src/components/ViennaEditor/ViennaEditor.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



function ViennaEditor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 15px;\n  font-weight: normal;\n  font-style: normal;\n  padding-right: 15px;\n  user-select: none;\n  -webkit-user-select: none;\n"
    ]);
    ViennaEditor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














// SEE vienna-text-editor.md for more info on the editor
function ViennaEditor(param) {
    var editor = param.editor, initialValue = param.initialValue, _handleChange = param.handleChange, handleChange = _handleChange === void 0 ? function() {} : _handleChange, readOnly = param.readOnly, textSubtype = param.textSubtype, slashMenu = param.slashMenu, wrapperStyles = param.wrapperStyles, autoFocus = param.autoFocus, editorId = param.editorId, onPaste = param.onPaste, onContextMenu = param.onContextMenu;
    var wrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), displayedOptions = ref[0], setDisplayedSlashMenuOptions = ref[1]; // a list of filtered slashMenuOptions
    var ref1 = (0,react.useState)(null), commandRange = ref1[0], setCommandRange = ref1[1]; // a slate Range object that marks the slash command
    var ref2 = (0,react.useState)("none"), userSelect = ref2[0], setUserSelect = ref2[1]; // whether the user can select text. used only as a wekbkit value to prevent safari selection apocalypse
    var ref3 = (0,react.useState)(0), selectedIndex = ref3[0], setSelectedIndex = ref3[1]; // the index of the selected slash menu option
    var ref4 = (0,react.useState)("keyboard"), inputType = ref4[0], setInputType = ref4[1]; // whether the user is using the mouse or keyboard to navigate the slash menu
    var slashMenuOpen = displayedOptions && commandRange;
    var closeSelf = function() {
        // close the slash menu
        setCommandRange(null);
        setDisplayedSlashMenuOptions(null);
    };
    var handleSelect = function() {
        index_es/* Transforms.delete */.YR["delete"](editor, {
            at: commandRange
        }); // delete the range containing the command
        closeSelf(); // close self
        slashMenu === null || slashMenu === void 0 ? void 0 : slashMenu.onSelect(displayedOptions[selectedIndex]); // select the option
        helpers/* EnhancedEditor.resetFonts */.Xe.resetFonts(editor); // reset fonts
    };
    /**
   * Runs on keypress; used to bind keys to commands.
   */ var handleKeydown = function(e) {
        // check for formatting commands
        richTextHotkeys(editor, e);
        if (slashMenuOpen) {
            var handled = handleSlashMenuKeydown({
                e: e,
                inputType: inputType,
                setInputType: setInputType,
                selectedIndex: selectedIndex,
                setSelectedIndex: setSelectedIndex,
                displayedOptions: displayedOptions,
                selectOption: handleSelect,
                close: closeSelf
            }).handled;
            if (handled) {
                e.stopPropagation();
                return;
            }
        }
        var handled1 = true;
        switch(e.key){
            case "z":
                // check for undo/redo hotkeys
                if ((hotkeys/* MODIFIERS.COMMAND */.vA.COMMAND === "meta" ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey) && !e.shiftKey && !e.altKey && editor.history.undos.length > 0) {
                    dist_index_es/* HistoryEditor.undo */.MO.undo(editor);
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                }
                if ((hotkeys/* MODIFIERS.COMMAND */.vA.COMMAND === "meta" ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey) && !e.altKey && e.shiftKey && editor.history.redos.length > 0) {
                    dist_index_es/* HistoryEditor.redo */.MO.redo(editor);
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                }
                break;
            case "a":
                if (hotkeys/* MODIFIERS.COMMAND */.vA.COMMAND === "meta" ? e.metaKey : e.ctrlKey) {
                    // select all
                    index_es/* Transforms.select */.YR.select(editor, []);
                    e.preventDefault();
                }
                break;
            case "Tab":
                if (editor.selection && !e.shiftKey) {
                    try {
                        (0,helpers/* handleTab */.B1)(editor, e);
                    } catch (e1) {
                        // Needed if the user is spamming the tab key and the editor is not ready to handle it.
                        e.preventDefault();
                    }
                } else if (e.shiftKey) {
                    (0,helpers/* handleShiftTab */.DT)(editor, e);
                }
                break;
            case "Enter":
                (0,helpers/* handleEnter */.Bm)(editor, e);
                break;
            case "Backspace":
                if (!e.metaKey && !e.ctrlKey) {
                    (0,helpers/* handleBackspace */.WP)(editor, e);
                } else {
                    index_es/* Transforms.delete */.YR["delete"](editor, {
                        unit: "line",
                        reverse: true
                    });
                    e.preventDefault();
                }
                break;
            case "Escape":
                removeFocus();
                break;
            default:
                handled1 = false;
                break;
        }
        if (handled1) {
            e.stopPropagation();
        }
    };
    /**
   * Runs anytime the editor is updated. Used for slash menu management.
   */ var handleEditorChange = function() {
        var ref;
        // call the passed in handleChange function
        handleChange();
        var shouldMergeLists = editor.operations.find(function(op) {
            return op.type.slice(op.type.length - 4, op.type.length) === "node";
        }); // check if we should do a check for merging lists
        if (shouldMergeLists && shouldMergeLists.path) {
            // if we fail to merge the lists in a range, just merge the entire editor
            try {
                helpers/* EnhancedEditor.mergeLists */.Xe.mergeLists(editor, index_es/* Editor.range */.ML.range(editor, shouldMergeLists.path));
            } catch (e) {
            // if merging fails, ignore it
            }
        }
        var selection = editor.selection;
        // checking for bulleted or numbered lists
        if (((ref = editor.operations[0]) === null || ref === void 0 ? void 0 : ref.type) === "insert_text" && selection) {
            var currentNode = index_es/* Editor.node */.ML.node(editor, selection)[0];
            var currentNodeText = currentNode && currentNode.text;
            if (currentNodeText === "- ") {
                var ref1;
                // if the user has typed "- ", we might want to create a bullet if we are not already in one
                var currentElementType = (ref1 = editor.getFragment()[0]) === null || ref1 === void 0 ? void 0 : ref1.type;
                if (currentElementType === "plain") {
                    // if the current fragment type is plain, create a bullet list
                    helpers/* EnhancedEditor.bulletedList */.Xe.bulletedList(editor);
                    // merge lists if necessary
                    helpers/* EnhancedEditor.mergeLists */.Xe.mergeLists(editor);
                }
            } else if ((currentNodeText === null || currentNodeText === void 0 ? void 0 : currentNodeText.length) > 2) {
                var fragment = editor.getFragment()[0];
                // if the user has typed a number, followed by ". ", we might want to create a numbered list
                var numberRegex = currentNodeText.match(/[0123456789]+\. /);
                if (numberRegex && currentNodeText === numberRegex[0] && fragment.type === "plain") {
                    // if the current fragment type is plain, create a numbered list and contains nothing but the number, create a numbered list
                    helpers/* EnhancedEditor.numberedList */.Xe.numberedList(editor, Number(currentNodeText.slice(0, currentNodeText.length - 2)));
                    // merge lists if necessary
                    helpers/* EnhancedEditor.mergeLists */.Xe.mergeLists(editor);
                }
            }
        }
        // if slash menu is enabled, do slash menu stuff
        if (slashMenu) {
            var isContentChange = editor.operations.some(function(op) {
                return op.type !== "set_selection";
            }); // check if the change is a content change
            if (!isContentChange) {
                // if it's not a content change, we do not want to open the slash menu. this prevents the slash menu from opening when the user moves the cursor around a slash
                setDisplayedSlashMenuOptions(null); // if there are no commands, set the slashCommands to null
                setCommandRange(null); // if there are no commands, set the commandRange to null
                return;
            }
            // sanity check: make sure selection exists & we never want to show slash menu when there is an expanded selection
            if (selection && index_es/* Range.isCollapsed */.e6.isCollapsed(selection)) {
                var ref2 = (0,_sliced_to_array/* default */.Z)(index_es/* Range.edges */.e6.edges(selection), 1), start = ref2[0]; // get the start Point of the selection (though this is the same as the end Point in a collapsed selection)
                // get the starting point of the word second before the selection (due to commands such as heading 1 where there is a space)
                var prevWordStartPoint = index_es/* Editor.before */.ML.before(editor, start, {
                    unit: "word",
                    distance: 2
                });
                var beforePoint = prevWordStartPoint && (index_es/* Editor.before */.ML.before(editor, prevWordStartPoint) || prevWordStartPoint); // get the point before the start of the previous word if it exists. needed to include the potential '/' preceding the word
                var prevWordRange = beforePoint && index_es/* Editor.range */.ML.range(editor, beforePoint, start); // get the range from start of prevWord to selection
                var prevWordText = prevWordRange && index_es/* Editor.string */.ML.string(editor, prevWordRange); // grab the text
                var prevWordSlashMatches = prevWordText && prevWordText.match(/\/(.*)/); // check the previous word for slashes
                if (prevWordSlashMatches) {
                    // create a point for the final slash in the prevWordText by adjusting the offset of the prevWordRange
                    var slashPoint = {
                        path: start.path,
                        offset: Math.max(prevWordRange.focus.offset - prevWordText.length + prevWordText.lastIndexOf("/"), 0)
                    };
                    // create a range from the final slash to the end of the selection
                    var slashRange = index_es/* Editor.range */.ML.range(editor, slashPoint, start);
                    // set the slashMenuOptions to the list of potential slash menu options
                    setDisplayedSlashMenuOptions(helpers/* EnhancedEditor.getFilteredSlashMenuOptions */.Xe.getFilteredSlashMenuOptions(slashMenu.options, slashRange, editor));
                    // set the commandRange to the slashRange
                    setCommandRange(slashRange);
                    // break out of the function
                    return;
                }
            }
            setDisplayedSlashMenuOptions(null); // if there are no commands, set the slashCommands to null
            setCommandRange(null); // if there are no commands, set the commandRange to null
        }
        return;
    };
    // A leaf rendering function which we can use to customize the styling of leaves (pieces of text with the same styling applied)
    var renderLeaf = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaf, (0,_object_spread/* default */.Z)({}, props));
    }, []);
    var renderElement = (0,react.useCallback)(function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            subType: textSubtype
        }));
    }, [
        editor.children
    ]);
    var renderPlaceholder = function(param) {
        var children = param.children, attributes = param.attributes;
        if (!readOnly && editor.children[0].type === "plain") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPlaceholder, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                children: children
            }));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    // useEffect to autofocus when needed. slate is a bitch in this area, tread carefully. we were running into an issue
    // where only calling ReactEditor.focus would not actually focus the editor, but Editor.isFocused would be true - causing
    // various hotkey failures. ask jack for more info
    (0,react.useEffect)(function() {
        if (autoFocus) {
            // focus editor
            slate_react_dist_index_es/* ReactEditor.focus */.F3.focus(editor);
            // to magic to make stupid thing actually focus
            index_es/* Transforms.select */.YR.select(editor, {
                anchor: index_es/* Editor.start */.ML.start(editor, []),
                focus: index_es/* Editor.start */.ML.start(editor, [])
            });
        }
    }, []);
    // would be great if we could find a way to do this without refs. in the slate examples, they get focus management on mouseDownOutside for
    // free. we must be doing something to get in the way of that
    var removeFocus = function() {
        // Transforms.deselect(editor);
        slate_react_dist_index_es/* ReactEditor.deselect */.F3.deselect(editor);
        slate_react_dist_index_es/* ReactEditor.blur */.F3.blur(editor);
    };
    (0,useOnMouseDownOutside/* useOnMouseDownOutside */.V)(wrapperRef, function() {
        removeFocus(); // need to do this for chrome
        setUserSelect("none"); // and this for safari
    });
    var refocusOnEditor = function() {
        return slate_react_dist_index_es/* ReactEditor.focus */.F3.focus(editor);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: wrapperRef,
        style: wrapperStyles,
        onContextMenu: function(e) {
            return e.stopPropagation();
        },
        onMouseDown: function() {
            setUserSelect("text");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(slate_react_dist_index_es/* Slate */.mH, {
            editor: editor,
            value: initialValue,
            onChange: handleEditorChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(slate_react_dist_index_es/* Editable */.CX, {
                    id: editorId,
                    onKeyDown: handleKeydown,
                    renderLeaf: renderLeaf,
                    renderElement: renderElement,
                    style: {
                        height: "100%",
                        width: "100%",
                        padding: "15px",
                        position: "relative",
                        WebkitUserSelect: userSelect
                    },
                    placeholder: 'Type "/" for commands',
                    renderPlaceholder: renderPlaceholder,
                    readOnly: readOnly,
                    decorate: linkAndEmailDecorator,
                    onPaste: function(e) {
                        return onPaste && onPaste(e);
                    },
                    onContextMenu: function(e) {
                        return onContextMenu && onContextMenu(e);
                    },
                    scrollSelectionIntoView: helpers/* scrollSlateIntoView */.bD
                }),
                slashMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlashMenu, {
                    close: closeSelf,
                    handleSelect: handleSelect,
                    displayedOptions: displayedOptions,
                    commandRange: commandRange,
                    elementRef: slashMenu === null || slashMenu === void 0 ? void 0 : slashMenu.positionRef,
                    inputType: inputType,
                    setInputType: setInputType,
                    selectedIndex: selectedIndex,
                    setSelectedIndex: setSelectedIndex,
                    refocusOnEditor: refocusOnEditor
                })
            ]
        })
    });
}
var StyledPlaceholder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74ebda64-0"
})(ViennaEditor_templateObject());

;// CONCATENATED MODULE: ./src/components/ViennaEditor/index.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 


/***/ }),

/***/ 64304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ initializeViennaEditor; }
});

// EXTERNAL MODULE: ../../node_modules/slate/dist/index.es.js + 1 modules
var index_es = __webpack_require__(92144);
// EXTERNAL MODULE: ../../node_modules/slate-history/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(72845);
// EXTERNAL MODULE: ../../node_modules/slate-react/dist/index.es.js
var slate_react_dist_index_es = __webpack_require__(70517);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14129);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(66420);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(5170);
// EXTERNAL MODULE: ../../node_modules/slate-hyperscript/dist/index.es.js + 1 modules
var slate_hyperscript_dist_index_es = __webpack_require__(42279);
;// CONCATENATED MODULE: ./src/components/ViennaEditor/lib/withHtml.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




var ELEMENT_TAGS = {
    BLOCKQUOTE: function() {
        return {
            type: "quote"
        };
    },
    H1: function() {
        return {
            type: "plain"
        };
    },
    H2: function() {
        return {
            type: "plain"
        };
    },
    H3: function() {
        return {
            type: "plain"
        };
    },
    H4: function() {
        return {
            type: "plain"
        };
    },
    H5: function() {
        return {
            type: "plain"
        };
    },
    H6: function() {
        return {
            type: "plain"
        };
    },
    IMG: function(el) {
        return {
            type: "image",
            url: el.getAttribute("src")
        };
    },
    LI: function() {
        return {
            type: "list-item"
        };
    },
    OL: function() {
        return {
            type: "numbered-list"
        };
    },
    P: function() {
        return {
            type: "plain"
        };
    },
    PRE: function() {
        return {
            type: "code"
        };
    },
    UL: function() {
        return {
            type: "bulleted-list"
        };
    },
    DIV: function() {
        return {
            type: "plain"
        };
    },
    TR: function() {
        return {
            type: "plain"
        };
    }
};
var TEXT_TAGS = {
    CODE: function() {
        return {
            code: true
        };
    },
    DEL: function() {
        return {
            strikethrough: true
        };
    },
    EM: function() {
        return {
            italic: true
        };
    },
    I: function() {
        return {
            italic: true
        };
    },
    S: function() {
        return {
            strikethrough: true
        };
    },
    STRONG: function() {
        return {
            bold: true
        };
    },
    U: function() {
        return {
            underline: true
        };
    },
    A: function(el) {
        return {
            link: el.getAttribute("href")
        };
    }
};
var deserialize = function(el) {
    // nodeType 3 is a text node
    if (el.nodeType === 3) {
        return el.textContent;
    // nodeType 1 is an element
    } else if (el.nodeType !== 1) {
        return null;
    } else if (el.nodeName === "BR") {
        return "\n";
    }
    var nodeName = el.nodeName;
    var parent = el;
    if (nodeName === "PRE" && el.childNodes[0] && el.childNodes[0].nodeName === "CODE") {
        parent = el.childNodes[0];
    }
    var children = Array.from(parent.childNodes).map(deserialize).flat();
    // stop children being empty and causing bugs
    if (children.length === 0) {
        children = [
            {
                text: ""
            }
        ];
    }
    if (el.nodeName === "BODY") {
        return (0,slate_hyperscript_dist_index_es/* jsx */.tZ)("fragment", {}, children);
    }
    // look through the element tags and check if the element is one of them
    if (ELEMENT_TAGS[nodeName]) {
        // if it is, set the attributes to the attributes of the element
        var attrs = ELEMENT_TAGS[nodeName](el);
        // get the font if it exists
        var details = getDetails(el);
        // create an element of the appropriate type
        var element = (0,slate_hyperscript_dist_index_es/* jsx */.tZ)("element", attrs, children);
        // if the font exists, set the font of the element using the setFont function
        if (details) element.children = setFontDetails(details, element.children);
        // if any of the children has the type plain, move them up the tree (plain should be the first child)
        element.children = element.children.map(function(child) {
            if (child.type === "plain") {
                return child.children;
            }
            return child;
        }).flat();
        // return the element's children
        return element.children;
    }
    // look through the text tags and check if the element is one of them
    if (TEXT_TAGS[nodeName]) {
        // if it is, set the attributes to the attributes of the element
        var attrs1 = TEXT_TAGS[nodeName](el);
        // return with the formatting applied to the text, not the element
        return children.map(function(child) {
            return format(attrs1, child);
        });
    }
    var details1 = getDetails(el);
    if (details1) {
        var text = children.map(function(child) {
            if (typeof child === "string") return (0,_object_spread/* default */.Z)({}, (0,slate_hyperscript_dist_index_es/* jsx */.tZ)("text", {}, child), details1);
            if (child.text || child.text === "") return (0,_object_spread/* default */.Z)({}, child, details1);
            return child;
        });
        return text;
    }
    return children;
};
/**
 * A function to get font details stored in the element's attributes, rather than as a tag
 */ var getDetails = function(el) {
    var font = el.style.fontFamily;
    var fontWeight = el.style.fontWeight;
    if (font && (fontWeight === "bold" || fontWeight === "bolder" || fontWeight >= 600)) {
        return {
            font: font,
            bold: true
        };
    } else if (font) {
        return {
            font: font
        };
    } else if (fontWeight === "bold" || fontWeight === "bolder" || fontWeight >= 600) {
        return {
            fontWeight: true
        };
    }
    return;
};
/**
 * A function to set font details (font type, bold, etc...) of the text in an elemnt
 */ var setFontDetails = function(font, children) {
    // loop through each child
    return children.map(function(child) {
        // if the child has children, recursively call the function on the child
        // this ensures the font is only ever set on the text of the element
        if (child.children) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child), {
                children: setFontDetails(font, child.children)
            });
        }
        // otherwise if the child is a text element, set the font
        return (0,_object_spread/* default */.Z)({}, child, font);
    });
};
/**
 * A function to add the formatting to the text of an element (bold, italic, etc)
 */ var format = function(attrs, child) {
    // if the child has children, recursively call the function on the child
    // this ensures the formatting is only ever applied to the text of the element
    if (child.children) {
        var url = child.url;
        var type = child.type;
        return child.children.map(function(childOfChild) {
            return (0,slate_hyperscript_dist_index_es/* jsx */.tZ)("fragment", {
                type: type,
                url: url
            }, format(attrs, childOfChild));
        });
    }
    // otherwise if the child is a text element, add the formatting
    return (0,slate_hyperscript_dist_index_es/* jsx */.tZ)("text", attrs, child.text || child);
};
var withHtml = function(editor) {
    var insertData = editor.insertData, isInline = editor.isInline;
    editor.isInline = function(element) {
        return element.type === "link" ? true : isInline(element);
    };
    editor.insertData = function(data) {
        var catchSlateFragment = /data-slate-fragment="(.+?)"/m;
        var html = data.getData("text/html");
        // fragment handles the case in which the user pastes a fragment of Slate content, as this is stored wierdly in the HTML
        var ref = (0,_sliced_to_array/* default */.Z)(html.match(catchSlateFragment) || [], 2), fragment = ref[1];
        // if the data is html, we need to parse it, deserialize it, and insert it
        if (html && !fragment) {
            var parsed = new DOMParser().parseFromString(html, "text/html");
            var fragments = deserialize(parsed.body);
            try {
                index_es/* Transforms.insertNodes */.YR.insertNodes(editor, fragments, checkListInFragment(fragments));
            } catch (e) {
                index_es/* Transforms.insertFragment */.YR.insertFragment(editor, fragments);
            }
            checkListItems(editor);
            return;
        }
        // otherwise, just insert the data as plain text
        insertData(data);
        checkListItems(editor);
    };
    return editor;
};
var checkListInFragment = function(fragment) {
    // a function to stop list items containing another list
    // for each item in the fragment
    return fragment.map(function(parent) {
        // if the item is a list
        if (parent.type === "bulleted-list" || parent.type === "numbered-list") {
            // call this function recursivelly on the children of the list
            return {
                type: parent.type,
                children: checkListInFragment(parent.children).flat()
            };
        } else if (parent.type === "list-item") {
            // if the item is a list item, check if it contains a list
            var newParent = [];
            parent.children.map(function(child) {
                // if it does contain a list, return the list
                if (child.type === "bulleted-list" || child.type === "numbered-list") {
                    // call the function recursivelly on the children of the list
                    newParent.push({
                        type: child.type,
                        children: checkListInFragment(child.children).flat()
                    });
                } else if (newParent.length && newParent[newParent.length - 1].type === "list-item" && child.type !== "list-item") {
                    // if there is a previous list item to add text to, add the text to the previous list item
                    newParent[newParent.length - 1].children.push(child);
                } else {
                    // otherwise, add the text to a new list item
                    newParent.push({
                        type: "list-item",
                        children: [
                            child
                        ]
                    });
                }
            }).flat();
            return newParent;
        } else if (parent.children) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parent), {
                children: checkListInFragment(parent.children).flat()
            });
        } else {
            // otherwise, we are looking at text so return the item
            return parent;
        }
    });
};
/**
 * This function turns any plain text in lists into list items. This is needed as after
 * pasting text into a list, the text is not turned into a list item.
 */ var checkListItems = function(editor) {
    // for every plain text node in the editor
    var nodes = index_es/* Editor.nodes */.ML.nodes(editor, {
        at: [],
        match: function(n) {
            return n.type === "plain";
        }
    });
    // set the initial value of the node
    var node = nodes.next();
    // while there are nodes to check
    while(!node.done){
        // if the path length of the node is greater than 1, we must be in a list
        if (node.value[1].length > 1) {
            // set the node type to list-item
            index_es/* Transforms.setNodes */.YR.setNodes(editor, {
                type: "list-item"
            }, {
                at: node.value[1]
            });
        }
        // move to the next node
        node = nodes.next();
    }
};

;// CONCATENATED MODULE: ./src/components/ViennaEditor/lib/initialize.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 



/**
 * Initialize a slate react editor with html pasting and undo/redo support.
 */ var initializeViennaEditor = function() {
    return withHtml((0,slate_react_dist_index_es/* withReact */.BU)((0,dist_index_es/* withHistory */.VC)((0,index_es/* createEditor */.Jh)())));
};


/***/ })

}]);